import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams, useLocation, Await } from 'react-router-dom';
import { pdfjs } from 'react-pdf';

import axios from 'axios';

import Modal from "../components/modal";

import { useAlert } from '../context/alertContext';

import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification } from 'firebase/auth';


import { useAuth } from '../context/AuthContext.js';

import { useFichario } from '../context/ficharioContext.js';

import Login from '../components/login.js';

import { useLoading } from '../context/loadingContext.js';

import { useCooldown } from "../context/cooldownContext.js";

import { axiosWithAuth } from '../services/api.js';

import Timer from './timer.js';



pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/js/pdf.worker.mjs`;


const Steps = () => {

    const navigate = useNavigate();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [currentStep, setCurrentStep] = useState(() => {
        const savedStep = localStorage.getItem('currentStep');
        return savedStep !== null ? parseInt(savedStep) : 0;
    });
    const [currentStepPrpps, setCurrentStepPrpps] = useState(0);
    const [cnisFile, setCnisFile] = useState(null);
    const [output, setOutput] = useState('');
    const [file, setFile] = useState(null);
    const [concessaoFile, setConcessaoFile] = useState(null);
    const [dadosCnis, setDadosCnis] = useState([]);
    const [cnis, setCnis] = useState([]);
    const [dadosCarta, setDadosCarta] = useState([]);
    const [dadosCnisCompletos, setDadosCnisCompletos] = useState([]);


    const { setLoading } = useLoading();

    const [dibParaCalc, setDibParaCalc] = useState([]);

    const [maiorDataAposentadoria, setMaiorDataAposentadoria] = useState(null);

    const [prpps, setPrpps] = useState([]);
    const [temPrpps, setTemPrpps] = useState(false);
    const [prppsRespondido, setPrppsRespondido] = useState(false);
    const [removerPrpps, setRemoverPrpps] = useState([]);
    const [removerPrppsAverba, setRemoverPrppsAverba] = useState([]);
    const [dadosParaAverbacao, setDadosParaAverbacao] = useState([]);
    const [aposentou, setAposentou] = useState(false);



    const [allTextCnis, setAllTextCnis] = useState(null);
    const [allTextCarta, setAllTextCarta] = useState(null);



    const { showAlert } = useAlert();
    const [searchParams] = useSearchParams();


    const { fichario, fetchFichario } = useFichario();


    const { modoLogin, setModoLogin } = useFichario();

    const { cooldown, cooldownWhats, startCooldown } = useCooldown();

    const [showPassword, setShowPassword] = useState(false);

    const [paymentId, setPaymentId] = useState(null);


    const [formData, setFormData] = useState({
        nomeCompleto: '',
        cpf: '',
        celular: '',
        cep: '',
        estado: '',
        cidade: '',
        bairro: '',
        rua: '',
        numero: '',
        nomeCompletoOutro: '',
        cpfOutro: '',
        cepOutro: '',
        estadoOutro: '',
        cidadeOutro: '',
        bairroOutro: '',
        ruaOutro: '',
        numeroOutro: '',
        funcionarioPublico: '',
        aposentadoriaPublica: '',
        orgaoTrabalho: '',
        dataAdmissao: '',
        orgaoTrabalhoSegunda: '',
        dataAdmissaoSegunda: '',
        aposentadoriaRegime: '',
        pretendeAposentar: '',
        averbacao: '',
        aposentadorias: [],
        averbacoes: [],
        orgaos: [{ orgaoTrabalho: "", dataAdmissao: "", dataFim: "" }],
        email: "",
        confirmEmail: "",
        password: "",
        confirmPassword: "",
        aceitoTermos: false,
        nomeCartao: "",
        numeroCartao: "",
        vencimento: "",
        vencimentoAno: "",
        vencimentoMes: "",
        cvc: "",
        id_pg: '',
        data_pg: '',
        valor_pg: '',
        status: '',
        compras: [],
        ids_pg: []
    });


    const [cartaData, setCartaData] = useState({
        dip: '',
        dib: '',
        rmi: '',
    });


    const [errors, setErrors] = useState({
        nomeCompleto: false,
        cpf: false,
        cep: false,
        estado: false,
        cidade: false,
        rua: false,
        numero: false,
        aceitoTermos: false,
    });

    const [dcbDate, setDcbDate] = useState("");
    const [allTextProcessado, setAllTextProcessado] = useState(false);


    const MAX_FILE_SIZE = 2 * 1024 * 1024;


    const baseURL = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_DEV_URL
        : 'https://revisaja-0b95e6e3ff11.herokuapp.com';


    const mpi_env = process.env.NODE_ENV === 'development'
        ? 'SDB'
        : 'PDR';


    const mpi_URL = process.env.NODE_ENV === 'development'
        ? 'https://mpisandbox.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js'
        : 'https://mpi.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js';


    const merchant_URL = process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000'
        : 'https://revisajaaposentadoria.com.br';


    const sop_env = process.env.NODE_ENV === 'development'
        ? 'sandbox'
        : 'production';


    // const api = useRef(null);
    // const [error, setError] = useState(null);

    const { currentUser, emailVerified, refreshUser } = useAuth();
    const uid = currentUser?.uid;
    ////console.log("uid:", uid, temPrpps);

    const [ccOutraPessoa, setCcOutraPessoa] = useState();

    const location = useLocation();

    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const [temRevisao, setTemRevisao] = useState(false);
    const [extraido, setExtraido] = useState(false);

    const estadosValidos = [
        "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
        "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
        "RS", "RO", "RR", "SC", "SP", "SE", "TO"
    ];

    const [cepSemBairro, setCepSemBairro] = useState(false);
    const [cepSemBairroOutro, setCepSemBairroOutro] = useState(false);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTestModalOpen, setIsTestModalOpen] = useState(false);


    const modalResolveRef = useRef(null);
    const modalContentRef = useRef(null);

    let aposentadoriasVinculos;
    const [averbacoesVinculo, setAverbacoesVinculo] = useState();



    const [metodoPagamento, setMetodoPagamento] = useState("");
    const [qrCodeGerado, setQrCodeGerado] = useState(false);
    const [qrCodeImage, setQrCodeImage] = useState("");
    const [tempoExpiracao, setTempoExpiracao] = useState(null);
    const [copiaColaPix, setCopiaColaPix] = useState("");
    const nomeCartaoRef = useRef(null);
    const pixRef = useRef(null);



    useEffect(() => {

        if (tempoExpiracao != null) {
            setCurrentStep(1);
            setMetodoPagamento("pix");
        }

    }, [tempoExpiracao]);



    useEffect(() => {

        if (metodoPagamento === "pix" && !qrCodeGerado) {
            handleQrCode();
        }

        const scrollTo = (element) => {
            if (!element) return;
            setTimeout(() => {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }, 300);
        };

        if (metodoPagamento === "cartao") scrollTo(nomeCartaoRef.current);
        if (metodoPagamento === "pix") scrollTo(pixRef.current);

    }, [metodoPagamento]);





    useEffect(() => {
        const erro = searchParams.get("erro");
        if (erro === "autenticacao") {
            showAlert("Não conseguimos autenticar o pagamento. Tente novamente.", 'tempo', 'erro');
        }

        const dadosPix = localStorage.getItem("pixPagamento");

        if (dadosPix) {
            const { qrCodeBase64, expiracao, compraId, copiaCola } = JSON.parse(dadosPix);
            const tempoRestante = new Date(expiracao) - new Date();

            if (tempoRestante > 0) {
                setQrCodeImage(`data:image/png;base64,${qrCodeBase64}`);
                setTempoExpiracao(new Date(expiracao));
                setQrCodeGerado(true);
                setPaymentId(compraId);
                setCopiaColaPix(copiaCola || "");
            } else {
                localStorage.removeItem("pixPagamento");
            }
        }

        // setTimeout(() => {
        //     try {
        //         channelRef.current?.postMessage({ type: "request-data" });
        //     } catch (e) {
        //         console.warn("Erro ao enviar request-data:", e);
        //     }
        // }, 0);

    }, []);


    useEffect(() => {
        // Captura a query string da URL
        const params = new URLSearchParams(location.search);
        const erro = params.get("erro");
        if (erro === "autenticacao" || erro === "pagamento") {
            setCurrentStep(0);
            localStorage.setItem("currentStep", "0");
            window.history.replaceState({}, document.title, location.pathname);
        }

    }, [location.search]);



    useEffect(() => {
        const savedStep = localStorage.getItem('currentStep');

        if (savedStep !== null) {
            const parsedStep = parseInt(savedStep);

            if (parsedStep > 1) {
                setCurrentStep(0);
                localStorage.setItem('currentStep', '0');
                navigate('/');
            }

            if (parsedStep === 0 || currentUser) {
                setCurrentStep(parsedStep);

            } else {
                setCurrentStep(0);
                localStorage.setItem('currentStep', '0');
            }
        }
    }, [currentUser]);




    useEffect(() => {
        localStorage.setItem('currentStep', currentStep);
        if (currentStep) {
            window.scrollTo(0, 0);
        }
    }, [currentStep]);




    useEffect(() => {
        if (fichario?.user) {
            setFormData(prev => ({
                ...prev,
                ...fichario.user,
                ...fichario.compra,
                confirma_cpf: fichario.user.cpf ?? "",
                nomeCompleto: fichario.user.nomeCompleto,
                cpf: fichario.user.cpf,
                cep: fichario.user.cep,
                rua: fichario.user.rua,
                bairro: fichario.user.bairro,
                cidade: fichario.user.cidade,
                estado: fichario.user.estado,
                numero: fichario.user.numero,
                celular: formatCelular(fichario.user.celular),
            }));
        }

        if (fichario?.user?.enviouDocs) {
            setIsTestModalOpen(true);
            setExtraido(true);
            setAllTextCarta(fichario?.user?.allTextCarta);
            setAllTextCnis(fichario?.user?.allTextCnis);

            if (fichario?.user?.temRevisao) {
                setTemRevisao(true);
            }
        }

    }, [fichario]);







    const handleCheckUser = async () => {
        const emailVerified = await refreshUser();

        if (emailVerified) {
            showAlert("E-mail verificado com sucesso!", "tempo", "ok");
        } else {
            showAlert("Por favor, verifique seu e-mail.", "tempo", "erro");
        }

    };







    // const channelRef = useRef(null);

    // useEffect(() => {
    //     channelRef.current = new BroadcastChannel("upload_channel");
    //     return () => channelRef.current.close();
    // }, []);




    // useEffect(() => {
    //     const channel = channelRef.current;
    //     if (!channel) return;

    //     const handler = (event) => {
    //         const { type, file, value } = event.data;

    //         if (type === "cnisFile" && !cnisFile) setCnisFile(file);
    //         if (type === "allTextCnis" && !allTextCnis) setAllTextCnis(value);

    //         if (type === "concessaoFile" && !concessaoFile) setConcessaoFile(file);
    //         if (type === "allTextCarta" && !allTextCarta) setAllTextCarta(value);

    //         if (type === "cartaData" && (cartaData?.rmi === "" || cartaData === null)) setCartaData(value);


    //         if (type === "request-data") {
    //             try {
    //                 if (cnisFile) channel.postMessage({ type: "cnisFile", file: cnisFile });
    //                 if (allTextCnis) channel.postMessage({ type: "allTextCnis", value: allTextCnis });

    //                 if (concessaoFile) channel.postMessage({ type: "concessaoFile", file: concessaoFile });
    //                 if (allTextCarta) channel.postMessage({ type: "allTextCarta", value: allTextCarta });
    //                 if (cartaData) channel.postMessage({ type: "cartaData", value: cartaData });
    //             } catch (e) {
    //                 console.warn("BroadcastChannel fechado ao responder request-data:", e);
    //             }
    //         }

    //     };

    //     channel.addEventListener("message", handler);

    //     return () => channel.removeEventListener("message", handler);

    // }, [cnisFile, allTextCnis, concessaoFile, allTextCarta]);


    // useEffect(() => {

    //     if (currentStep === 1 && (!cnisFile || !concessaoFile)) {
    //         console.log("teste", cnisFile)
    //         setCurrentStep(0);
    //     }

    // }, []);





    function limparAntesJulNoveQuatro(dados) {

        if (!Array.isArray(dados)) {
            console.warn('Esperado array de vínculos, mas recebeu:', typeof dados);
            return [];
        }

        return dados.map(vinculo => {
            const salariosOriginais = vinculo.salarios || [];

            const salariosFiltrados = salariosOriginais.filter(salario => {
                if (!salario.competencia || !/^\d{2}\/\d{4}$/.test(salario.competencia)) {
                    console.warn('Competência inválida:', salario.competencia);
                    return false;
                }

                const [mes, ano] = salario.competencia.split('/').map(Number);
                return ano > 1994 || (ano === 1994 && mes >= 7);
            });

            if (salariosFiltrados.length < salariosOriginais.length) {
                //// console.log(`🔍 Vínculo alterado (salários removidos):`, vinculo);
            }

            return {
                ...vinculo,
                salarios: salariosFiltrados,
            };
        });

    };


    const formatarData = (date) => {
        if (!(date instanceof Date) || isNaN(date)) return null;

        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();

        return `${dia}/${mes}/${ano}`;
    };




    const handleAposentadoChange = (vinculo, resposta) => {

        try {

            if (!vinculo || typeof resposta !== 'string') {
                console.warn('⚠️ Entrada inválida em handleAposentadoChange:', { vinculo, resposta });
                return;
            }

            setRemoverPrpps((prev) => {
                let atualizado;

                if (resposta === "sim") {
                    if (prev.length >= 2) {
                        return prev;
                    }
                    atualizado = [...prev, vinculo];
                } else {
                    atualizado = prev.filter((item) => item !== vinculo);
                }

                setAposentou(atualizado.length > 0);

                // // console.log(atualizado);
                return atualizado;
            });


        } catch (err) {
            //console.error('❌ Erro em handleAposentadoChange:', err, { vinculo, resposta });
        }
    };



    const handleConfirmAposentadoria = async () => {
        // showAlert("Informações salvas com sucesso!");
        // console.log("dados APOSENTADO POR (removerPrpps) teste: ", removerPrpps);
        // console.log("dadosCnis teste: ", dadosCnis);

        // console.log("dadosCnisCompletos", dadosCnisCompletos);

        try {

            const filtrado = dadosCnisCompletos.filter(item =>
                !removerPrpps.some(removerItem => removerItem.vinculo === item.vinculo)
            );

            const filtradoLimpo = limparAntesJulNoveQuatro(filtrado);

            setDadosCnis(filtradoLimpo);

            //console.log("dados Filtrados teste: ", filtradoLimpo);

            ////console.log("removerPrpps", removerPrpps);


            const maiorDataInicio = removerPrpps.reduce((max, obj) => {
                if (!obj.data_inicio) return max;

                const partes = obj.data_inicio.split('/').map(Number);
                let dia = 1, mes, ano;

                if (partes.length === 2) {
                    [mes, ano] = partes;
                } else if (partes.length === 3) {
                    [dia, mes, ano] = partes;
                } else {
                    return max;
                }

                const dataAtual = new Date(ano, mes - 1, dia);
                return dataAtual > max ? dataAtual : max;

            }, new Date(0));

            setMaiorDataAposentadoria(maiorDataInicio);

            ////console.log("Menor Data_Inicio teste: ", menorDataInicio, filtrado);
            ////console.log("Tipo de menorDataInicio:", typeof menorDataInicio);
            ////console.log("É data válida?", menorDataInicio instanceof Date && !isNaN(menorDataInicio));

            const dadosAntesDaMenorDataInicio = filtrado.flatMap(item => {
                //// console.log("---- Analisando item ----");
                //// console.log("Vínculo:", item.vinculo);
                //// console.log("Salários:", item.salarios);

                if (!Array.isArray(item.salarios)) {
                    //console.warn("Item sem array de salários:", item);
                    return [];
                }

                const salariosFiltrados = item.salarios.filter(salario => {

                    const competencia = salario.competencia;
                    //// console.log("Competência bruta:", competencia);

                    if (!competencia) {
                        // console.warn("Salário sem competência:", salario);
                        return false;
                    }

                    const partes = competencia.split('/').map(Number);
                    //// console.log("Partes da competência:", partes);

                    let dia = 1, mes, ano;
                    if (partes.length === 2) {
                        [mes, ano] = partes;
                    } else if (partes.length === 3) {
                        [dia, mes, ano] = partes;
                    } else {
                        //console.warn("Formato inesperado:", competencia);
                        return false;
                    }

                    if (isNaN(mes) || isNaN(ano)) {
                        //console.warn("Competência inválida:", { mes, ano });
                        return false;
                    }

                    const dataCompetencia = new Date(ano, mes - 1, dia);
                    const anterior = dataCompetencia < maiorDataInicio;
                    //// console.log("Data convertida:", dataCompetencia, "| menorDataInicio:", menorDataInicio, "| É anterior?", anterior);

                    return anterior;
                });

                if (salariosFiltrados.length > 0) {
                    return [{ ...item, salarios: salariosFiltrados }];
                } else {
                    ////console.log("Todos os salários foram depois da menorDataInicio. Item removido.", item);
                    return [];
                }
            });


            //console.log("teste: ", dadosAntesDaMenorDataInicio);

            // const aposentadoriasVinculos = removerPrpps.map(vinculo => vinculo.vinculo);

            aposentadoriasVinculos = removerPrpps.map(vinculo => ({
                vinculo: vinculo.vinculo,
                data_inicio: vinculo.data_inicio,
                data_fim: vinculo.data_fim
            }));

            setFormData(prev => ({
                ...prev,
                aposentadorias: aposentadoriasVinculos
            }));


            //console.log("dadosParaAverbação", dadosAntesDaMenorDataInicio);

            setDadosParaAverbacao(ordenarPorDataInicio(dadosAntesDaMenorDataInicio));


            if (dadosAntesDaMenorDataInicio.length >= 1 && aposentou) {

                handleNextPrpps();


            } else {
                // Chamar aqui o Redis passando "filtrado limpando antesJulNovequatro"
                try {
                    //console.log('prppps,', filtradoLimpo);
                    const res = await enviarDadosParaRedis('prpps', filtradoLimpo);
                    atualizarPreExtracao(filtradoLimpo);
                    // setPrppsAp(filtradoLimpo);

                    ////console.log('Resposta:', res);

                    setPrppsRespondido(true);
                    localStorage.setItem("prppsRespondido", "true");
                    ////console.log("entrou aqui4");
                    closeModal();
                    showAlert('Informações salvas com sucesso!', 'tempo', 'ok');

                } catch (err) {
                    //console.error('Erro ao salvar no Redis:', err);
                    showAlert('Erro ao salvar os dados. Tente novamente.', 'tempo', 'erro');
                    // Aqui você pode ainda reabrir o modal ou manter algum estado de erro, se quiser
                }

            }

        } catch (err) {
            //console.error('❌ Erro inesperado em handleConfirmAposentadoria:', err);
            showAlert('Erro inesperado. Tente novamente.', 'tempo', 'erro');
        }


    };




    const handleAverbacaoChange = (vinculo, resposta) => {

        try {

            setRemoverPrppsAverba((prev) => {
                if (resposta === "sim") {
                    return [...prev, vinculo];
                } else {
                    return prev.filter((item) => item !== vinculo);
                }
            });

        } catch (err) {
            //console.error('❌ Erro em handleAverbacaoChange:', err, { vinculo, resposta });
        }
    };




    const handleConfirmAverbacao = async () => {
        ////console.log("Remover averbação: ", removerPrppsAverba);
        ////console.log("dadosCnis: ", dadosCnis);
        try {
            const novosDadosCnis = dadosCnis
                .map((item, index) => {
                    // Filtra os objetos de remoção que tenham o mesmo 'vinculo' do item
                    const removals = removerPrppsAverba.filter(removerItem => removerItem.vinculo === item.vinculo);

                    // Se houver alguma remoção para esse vinculo...
                    if (removals.length > 0) {
                        ////console.log(`[6] Encontrou remoções para item ${index}`);
                        // Coleta todas as competências a serem removidas (supondo que cada objeto de remoção tenha um array 'salarios' e cada salário tenha o campo 'competencia')
                        const competenciasRemover = removals.flatMap(rem => Array.isArray(rem.salarios) ? rem.salarios.map(sal => sal.competencia) : []);

                        if (!Array.isArray(item.salarios)) {
                            console.warn(`⚠️ Item sem salários válidos (array):`, item);
                            return item; // ou `return null` se quiser descartar
                        }

                        // Filtra os 'salarios' do item: remove aqueles cuja competência esteja na lista
                        const novosSalarios = item.salarios.filter(sal => !competenciasRemover.includes(sal.competencia));

                        //// console.log(`[11] Novos salários após filtro:`, item.vinculo, novosSalarios);
                        // Se não sobrar nenhuma competência, retorna null para, posteriormente, remover o objeto
                        if (novosSalarios.length === 0) {
                            return null;
                        }

                        // Senão, retorna o objeto atualizado com o array 'salarios' filtrado
                        return { ...item, salarios: novosSalarios };
                    }

                    // Se não houver nenhum objeto de remoção para esse vinculo, mantém o item inalterado
                    return item;
                })
                // Remove os itens que ficaram com null (ou seja, sem nenhum salário)
                .filter(item => item !== null);

            // // console.log("novosDadosCnis", novosDadosCnis);

            setDadosCnis(novosDadosCnis);


            const averbacoes = removerPrppsAverba.map(vinculo => ({
                vinculo: vinculo.vinculo,
                data_inicio: formatarData(maiorDataAposentadoria), // 👈 AQUI
                data_fim: vinculo.data_fim
            }));


            //console.log("averbs", averbacoes);

            setFormData(prev => ({
                ...prev,
                averbacoes: averbacoes
            }));

            setAverbacoesVinculo(averbacoes);

            const novosDadosCnisAtualizado = novosDadosCnis.map(item => {
                const averbacao = averbacoes.find(av => av.vinculo === item.vinculo);

                if (averbacao) {
                    return {
                        ...item,
                        data_inicio: averbacao.data_inicio, // 👈 sobrescreve
                        data_fim: averbacao.data_fim ?? item.data_fim
                    };
                }

                return item;
            });


            //Chama Redis e Passa dadosCnis todo (novosDadosCnis)
            //console.log("Chamando Redis Confirm Averbação", novosDadosCnisAtualizado);
            const res = await enviarDadosParaRedis('prpps', novosDadosCnisAtualizado);
            atualizarPreExtracao(novosDadosCnisAtualizado);
            //setPrppsAp(novosDadosCnisAtualizado);
            ////console.log('Resposta Redis Confirm Averbação:', res);
            setPrppsRespondido(true);
            localStorage.setItem("prppsRespondido", "true");
            closeModal();
            showAlert('Informações salvas com sucesso!', 'tempo', 'ok');



        } catch (err) {
            //console.error('❌ Erro ao salvar dados no Redis ou no processo de averbação:', err);
            showAlert('Erro ao salvar os dados. Tente novamente.', 'tempo', 'erro');
        }


    };



    const atualizarPreExtracao = async (prppsAp) => {

        setLoading(true);

        try {

            await auth.currentUser.reload();
            const idToken = await auth.currentUser.getIdToken(true);

            if (!idToken) {
                return;
            }

            //console.log("dadosValidação", cnisFile, concessaoFile, cartaData, allTextCarta, allTextCnis);

            //console.log("teste", prppsAp);

            // console.log("dadoscnis", dadosCnis);

            // let dadosCnisUnidos = [...dadosCnis, ...prppsAp];

            // console.log("unidos", dadosCnisUnidos);

            //return;

            const body = {
                updateData: prppsAp,
                nomeUser: formData.nomeCompleto,
                allTextCnis,
                allTextCarta
            };


            const response = await axios.post(`${baseURL}/revisao`, body, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`
                }
            });



            if (response?.data === true) {
                setTemRevisao(true);
                //console.log("response do atualiza + logica", response.data, response.data === true);
            }

            setExtraido(true);
            setIsTestModalOpen(true);

        } catch (err) {

            console.error('Erro ao tentar atualizar o PRPPS:', err);
            setOutput('Erro ao conectar com o servidor.');
            showAlert('Ocorreu um erro ao salvar seus dados. Por favor, tente novamente.', 'tempo', 'erro');
            setCnisFile(null);
            setConcessaoFile(null);
            setDibParaCalc(null);
            setCartaData(null);
            setLoading(false);
            setTemPrpps(false);
            setCurrentStep(0);
            localStorage.setItem("currentStep", "0");
            localStorage.setItem("prppsRespondido", "false");
            localStorage.setItem("temPrpps", "false");
            setAllTextCnis(null);
            setAllTextCarta(null);

            // try {
            //     await axios.post(`${baseURL}/logs`, {
            //         level: 'error',
            //         message: `Erro ao buscar dados.`,
            //         context: 'steps',
            //         userId: uid || null,
            //         stack: 'precessarAllText'
            //     });
            // } catch (logErr) {
            //     console.warn('Falha ao enviar log para /logs:', logErr.message);
            // }
            setLoading(false);

            return false;


        }

        setLoading(false);

    };




    const scrollToTop = () => {
        if (isModalOpen) {
            setTimeout(() => {
                if (modalContentRef.current) {
                    modalContentRef.current.scrollTop = 0;
                } else {
                    alert('modalContentRef.current é null');
                }
            }, 0);
        }
    };



    const handleNextPrpps = () => {

        try {

            if (aposentou) {
                setCurrentStepPrpps((prevStep) => prevStep + 1);
                scrollToTop();
            } else {
                closeModal();
            }

        } catch (err) {
            //console.error('❌ Erro ao avançar etapa PRPPS:', err);
        }

    };


    const handlePreviusPrpps = () => {
        setCurrentStepPrpps((prevStep) => prevStep - 1);
    };


    const abrirModalAsync = () => {
        return new Promise((resolve) => {
            modalResolveRef.current = resolve;
            setIsModalOpen(true);
        });
    };


    const openModal = () => {
        setIsModalOpen(true);
    };


    const closeModal = () => {
        if (modalResolveRef.current) {
            modalResolveRef.current(true);
            modalResolveRef.current = null;
        }
        setIsModalOpen(false);
    };



    const closeTestModal = () => {
        if (modalResolveRef.current) {
            modalResolveRef.current(true);
            modalResolveRef.current = null;
        }
        setIsTestModalOpen(false);
    };




    const handleNavigate = () => {
        navigate('/');
    };



    const isFormDataDifferent = (a, b) => {

        if (typeof a !== 'object' || a === null) {
            console.warn('⚠️ isFormDataDifferent: parâmetro "a" inválido:', a);
            return true; // Considera diferente se a for inválido
        }
        if (typeof b !== 'object' || b === null) {
            console.warn('⚠️ isFormDataDifferent: parâmetro "b" inválido:', b);
            return true; // Considera diferente se b for inválido
        }
        const camposParaComparar = ['nomeCompleto', 'cpf', 'cep', 'estado', 'cidade', 'rua', 'numero', 'celular'];

        return camposParaComparar.some(campo => {
            return (a[campo] || '') !== (b?.[campo] || '');
        });
    };





    const pushDataLayer = (eventName, data = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            ...data
        });
    };


    const handleNext = async () => {

        // console.log(formData);

        const emailVerified = await refreshUser();

        if (currentUser && !emailVerified && currentStep === 0) {
            showAlert("Por favor, verifique seu e-mail..", "tempo", "erro");
            return

        }


        try {

            if (currentStep === 0) {



                if (fichario?.user?.enviouDocs === true && (temPrpps && !prppsRespondido)) {
                    showAlert("Algo deu errado. Por favor, carregue os arquivos novamente.", "tempo", "erro");
                    setCnisFile();
                    setConcessaoFile();
                    setCurrentStep(0);
                    localStorage.setItem("currentStep", "0");
                    return
                }




                if ((temPrpps && prppsRespondido) || temPrpps === false) {

                    pushDataLayer('step_advance', {
                        current_step: 0,
                        next_step: 1,
                        step_name: 'pagamento'
                    });

                    setCurrentStep((prevStep) => prevStep + 1);

                } else {

                    showAlert('Erro inesperado. Por Favor, tente novamente.', 'tempo', 'erro');
                    setTemPrpps(false);
                    setCnisFile(null);
                    setConcessaoFile(null);
                    setCurrentStep(0);

                    return
                }


            }


        } catch (err) {
            //console.error('❌ Erro inesperado em handleNext:', err);
            showAlert('Erro inesperado. Tente novamente mais tarde.', 'tempo', 'erro');
        }


    };




    const handleSubmitFreeTest = async (e) => {
        e.preventDefault();


        const newErrors = {
            cnisFile: !cnisFile,
            concessaoFile: !concessaoFile,
        };

        if (currentUser) {
            refreshUser();
        }

        setErrors(newErrors);
        setIsSubmitted(true);

        if (Object.values(newErrors).includes(true)) {
            return;
        }


        //console.log('Formulário enviado com sucesso!', formData);

        const emailVerified = await refreshUser();

        if (currentUser && !emailVerified && currentStep === 0) {
            showAlert("Por favor, verifique seu e-mail.", "tempo", "erro");
            return

        }

        if (!allTextCnis || !allTextCarta) {
            showAlert("Por favor, carregue os arquivos novamente.", "tempo", "erro");
            setCurrentStep(0);
            localStorage.setItem("currentStep", "0");
            return
        }

        try {

            if (currentStep === 0) {

                if (!cnisFile || !concessaoFile) return


                //// console.log("formData", formData);
                const newErrors = {
                    ...errors,
                    email: formData.email === "",
                    password: formData.password === "",
                };

                //setFichario(formData);
                const camposComErro = Object.entries(newErrors)
                    .filter(([campo, temErro]) => temErro)
                    .map(([campo]) => campo);

                //// console.log("Campos com erro:", camposComErro, fichario);

                if (!currentUser) {

                    if (formData.password === "") {
                        newErrors.password = "Campo obrigatório";
                    }

                    if (formData.password.length > 0 && formData.password.length < 8) {
                        newErrors.password = "A senha deve ter pelo menos 8 caracteres.";
                    }

                }

                setErrors(newErrors);
                setIsSubmitted(true);

                const temErros = Object.values(newErrors).some(Boolean);
                //console.log("erros?", temErros, newErrors, uid, (temErros && !uid));

                if (temErros && !uid) return;


                if (allTextProcessado && extraido) {
                    setExtraido(true);
                    setIsTestModalOpen(true);
                    return;


                } else {

                    const processar = await processarAllText(cnisFile, concessaoFile, allTextCnis, allTextCarta);


                    if (processar) {


                        setAllTextProcessado(true);

                        if ((temPrpps && prppsRespondido) || temPrpps === false) {

                            pushDataLayer('teste_gratis', {
                                current_step: 0,
                                next_step: 1,
                                step_name: 'teste realizado'
                            });

                        } else {

                            showAlert('Erro inesperado. Por Favor, tente novamente.', 'tempo', 'erro');
                            //console.log("prpps", temPrpps);
                            setTemPrpps(false);
                            setCnisFile(null);
                            setConcessaoFile(null);
                            setCurrentStep(0);

                            return

                        }

                        //setCurrentStep((prevStep) => prevStep + 1);
                    } else {

                        return

                    }

                }

            }


        } catch (err) {
            //console.error('❌ Erro inesperado em handleNext:', err);
            showAlert('Erro inesperado. Tente novamente mais tarde.', 'tempo', 'erro');
        }

    };





    function formatCelular(value) {
        if (!value) return '';

        let numericValue = value.replace(/\D/g, '');

        return numericValue
            .replace(/^(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{1})(\d{4})(\d{4})$/, '$1 $2-$3');
    }




    const handleInputChange = async (e) => {
        const { name, value } = e.target;

        let formattedValue = value;

        //console.log("formDataInpt", value);

        if (name === "cpf" || name === "cpfOutro") {
            formattedValue = formatCPF(value);
        }

        if (name === "cep" || name === "cepOutro") {
            formattedValue = formatCEP(value);
        }

        if (name === 'estado' || name === "estadoOutro") {
            formattedValue = value.replace(/[^a-zA-ZÀ-ÿ]/g, '').toUpperCase();
        }

        if (name === "rua" || name === "ruaOutro" || name === "bairro" || name === "bairroOutro") {
            formattedValue = value.replace(/[^a-zA-ZÀ-ÿ0-9\s]/g, "");
        }




        if (name === 'celular') {
            let numericValue = value.replace(/\D/g, '');

            formattedValue = numericValue
                .replace(/^(\d{2})(\d)/, '($1) $2')
                .replace(/(\d{1})(\d{4})(\d{4})$/, '$1 $2-$3');
        }


        if (name === 'email') {
            let normalized = value.trim().toLowerCase();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            formattedValue = normalized;
        }


        if (name === 'nomeCompleto' || name === "nomeCompletoOutro") {
            formattedValue = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, '').toUpperCase();
        }

        // console.log(formData);

        if (name === "numero" || name === "numeroOutro") {
            const somenteNumeros = value.replace(/\D/g, ""); // mantém apenas 0-9
            formattedValue = somenteNumeros;
        }
        // Para numeroCartao e vencimento tratamos diferente abaixo, então só segue se não for esses casos

        // Se for numeroCartao: já processa e retorna
        // if (name === "numeroCartao") {
        //     const somenteNumeros = value.replace(/\D/g, '');
        //     // Salvamos sem espaço
        //     setFormData((prevFormData) => ({
        //         ...prevFormData,
        //         [name]: somenteNumeros,
        //     }));
        //     return;
        // }

        // Agora criamos o novo formData já atualizado para validações
        const newFormData = {
            ...formData,
            [name]: formattedValue,
        };

        setFormData(newFormData);

        // Validações que dependem do estado atualizado

        // Se for campos relacionados à aposentadoria, limpa erros específicos
        if (["aposentadoriaPublica", "aposentadoriaRegime", "pretendeAposentar"].includes(name)) {
            setErrors((prev) => ({
                ...prev,
                [name]: false,
            }));
        }

        // Caso o usuário escolha "NÃO" em funcionarioPublico, limpa campos relacionados
        if (name === "funcionarioPublico" && formattedValue === "NÃO") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                funcionarioPublico: formattedValue,
                aposentadoriaPublica: "",
                orgaoTrabalho: "",
                dataAdmissao: "",
                orgaoTrabalhoSegunda: "",
                dataAdmissaoSegunda: "",
                aposentadoriaRegime: "",
                averbacao: "",
                orgaos: []
            }));
        }


        if ((name === "cep") && value.length === 9) {
            try {
                const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${value}`);
                if (!response.ok) {
                    throw new Error("Erro ao buscar o CEP");
                }
                const data = await response.json();
                //console.log("cep API", data);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    estado: data.state,
                    cidade: data.city,
                    rua: data.street,
                    bairro: data.neighborhood,
                    estadoOutro: data.state,
                    cidadeOutro: data.city,
                    ruaOutro: data.street,
                    bairroOutro: data.neighborhood,
                }));
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    estado: false,
                    cidade: false,
                    rua: false,
                }));

                if (!data.neighborhood) {
                    setCepSemBairro(true);
                } else {
                    setCepSemBairro(false);
                }

            } catch (error) {
                //console.error("Erro ao buscar o endereço:", error);
            }
        }


        if ((name === "cepOutro") && value.length === 9) {
            try {
                const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${value}`);
                if (!response.ok) {
                    throw new Error("Erro ao buscar o CEP");
                }
                const data = await response.json();
                // console.log("cep API", data);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    estadoOutro: data.state,
                    cidadeOutro: data.city,
                    ruaOutro: data.street,
                    bairroOutro: data.neighborhood,
                    estadoOutro: data.state,
                    cidadeOutro: data.city,
                    ruaOutro: data.street,
                    bairroOutro: data.neighborhood,
                }));
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    estado: false,
                    cidade: false,
                    rua: false,
                }));

                if (!data.neighborhood) {
                    setCepSemBairroOutro(true);
                } else {
                    setCepSemBairroOutro(false);
                }

            } catch (error) {
                //console.error("Erro ao buscar o endereço:", error);
            }
        }

        // Se não entrou no caso funcionarioPublico = NÃO, atualiza normalmente (já fizemos acima, mas para garantir)
        if (!(name === "funcionarioPublico" && formattedValue === "NÃO")) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: formattedValue
            }));
        }


        const dadosParaValidar = {
            email: (newFormData.email || fichario?.email || "").trim().toLowerCase(),
            senha: newFormData.password || "",
            nomeCompleto: newFormData.nomeCompleto || fichario?.nomeCompleto || "",
            cpf: newFormData.cpf || fichario?.cpf || "",
            celular: newFormData.celular || fichario?.celular || "",
            cep: newFormData.cep || fichario?.cep || "",
            estado: newFormData.estado || fichario?.estado || "",
            cidade: newFormData.cidade || fichario?.cidade || "",
            bairro: newFormData.bairro || fichario?.bairro || "",
            rua: newFormData.rua || fichario?.rua || "",
            numero: newFormData.numero || fichario?.numero || "",
            nomeCompletoOutro: newFormData.nomeCompletoOutro || "",
            cpfOutro: newFormData.cpfOutro || "",
            cepOutro: newFormData.cepOutro || "",
            estadoOutro: newFormData.estadoOutro || "",
            cidadeOutro: newFormData.cidadeOutro || "",
            bairroOutro: newFormData.bairroOutro || fichario?.bairroOutro || "",
            ruaOutro: newFormData.ruaOutro || "",
            numeroOutro: newFormData.numeroOutro || "",
        };

        let newErrors = {
            email:
                dadosParaValidar.email === ""
                    ? "*Obrigatório"
                    : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dadosParaValidar.email)
                        ? "*E-mail inválido"
                        : "",
            password:
                dadosParaValidar.password === ""
                    ? "*Obrigatório"
                    : dadosParaValidar.senha.length < 2
                        ? "*A senha deve ter pelo menos 8 caracteres"
                        : "",
            nomeCompleto: dadosParaValidar.nomeCompleto === "" ? "*Obrigatório" : "",
            cpf: dadosParaValidar.cpf === ""
                ? "*Obrigatório"
                : dadosParaValidar.cpf.replace(/\D/g, '').length !== 11
                    ? "CPF inválido"
                    : "",
            celular: dadosParaValidar.celular === ""
                ? "*Obrigatório"
                : dadosParaValidar.celular.replace(/\D/g, '').length !== 11
                    ? "*Celular inválido"
                    : "",
            cep: dadosParaValidar.cep === ""
                ? "*Obrigatório"
                : dadosParaValidar.cep.replace(/\D/g, '').length !== 8
                    ? "CEP inválido"
                    : "",
            estado: dadosParaValidar.estado === ""
                ? "*Obrigatório"
                : !estadosValidos.includes(dadosParaValidar.estado.toUpperCase())
                    ? "Estado inválido"
                    : "",
            cidade: dadosParaValidar.cidade === "" ? "*Obrigatório" : "",
            bairro: dadosParaValidar.bairro === "" ? "*Obrigatório" : "",
            rua: dadosParaValidar.rua === "" ? "*Obrigatório" : "",
            numero: dadosParaValidar.numero === "" ? "*Obrigatório" : "",
        };


        if (ccOutraPessoa && metodoPagamento === "cartao") {

            newErrors = {
                ...newErrors,
                nomeCompletoOutro: dadosParaValidar.nomeCompletoOutro === "" ? "*Obrigatório" : "",
                cpfOutro: dadosParaValidar.cpfOutro === ""
                    ? "*Obrigatório"
                    : dadosParaValidar.cpfOutro.replace(/\D/g, '').length !== 11
                        ? "*CPF inválido"
                        : "",
                cepOutro: dadosParaValidar.cepOutro === ""
                    ? "*Obrigatório"
                    : dadosParaValidar.cepOutro.replace(/\D/g, '').length !== 8
                        ? "*CEP inválido"
                        : "",
                estadoOutro: dadosParaValidar.estadoOutro === ""
                    ? "*Obrigatório"
                    : !estadosValidos.includes(dadosParaValidar.estadoOutro.toUpperCase())
                        ? "*Estado inválido"
                        : "",
                cidadeOutro: dadosParaValidar.cidadeOutro === "" ? "*Obrigatório" : "",
                bairroOutro: dadosParaValidar.bairroOutro === "" ? "*Obrigatório" : "",
                ruaOutro: dadosParaValidar.ruaOutro === "" ? "*Obrigatório" : "",
                numeroOutro: dadosParaValidar.numeroOutro === "" ? "*Obrigatório" : "",
            };

        }

        setErrors(newErrors);
        // DEBUG:
        //// console.log("formData atualizado:", newFormData);
    };




    const enviarDadosParaRedis = async (tipo, dados) => {

        if (!Array.isArray(dados)) {
            throw new Error('Esperada uma lista de objetos');
        }


        try {

            await auth.currentUser.reload();
            const idToken = await auth.currentUser.getIdToken(true);
            const api = await axiosWithAuth();

            if (!api) {
                return;
            }

            const response = await api.put(`/redis/${tipo}`, dados, {
                headers: { Authorization: `Bearer ${idToken}` }
            });

            return response.data;

        } catch (err) {
            //console.error('Erro ao enviar dados para Redis:', err.message);
            try {
                await axios.post(`${baseURL}/logs`, {
                    level: 'error',
                    message: `Erro ao buscar dados: `,
                    context: 'steps',
                    userId: uid || null,
                    stack: 'enviarDadosParaRedis'
                });
            } catch (logErr) {
                //console.warn('Falha ao enviar log para /logs:', logErr.message);
            }


            throw err;
        }

    };







    const handlePrevious = () => {
        setCurrentStep((prevStep) => prevStep - 1);
    };


    const base64ToFile = (base64Data, filename) => {
        const arr = base64Data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };


    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = (error) => reject(error);
        });
    };




    const handleCnisUpload = async (event) => {
        try {

            ////console.log("chamou cnis");
            const selectedFile = event.target.files[0];
            const input = event.target;
            input.value = null;

            if (selectedFile.type !== 'application/pdf') {
                showAlert('Por favor, selecione um arquivo PDF válido.', 'tempo', 'erro');
                return;
            }

            if (selectedFile.size > MAX_FILE_SIZE) {
                showAlert('O arquivo excede o tamanho máximo de 2 MB.', 'tempo', 'erro');
                return;
            }

            //console.log("cnisfile", selectedFile);

            setFile(selectedFile);
            setCnisFile(selectedFile);


            if (selectedFile) {

                pushDataLayer('document_upload', {
                    file_type: 'cnis',
                    file_name: selectedFile.name
                });

                extractTextFromPdf(selectedFile, 'cnis');
            }

        } catch (err) {

            showAlert('Erro ao processar o arquivo. Tente novamente.', 'tempo', 'erro');
        }

    };




    const handleConcessaoUpload = async (event) => {

        try {
            ////console.log("chamou carta");
            const selectedFile = event.target.files[0];
            const input = event.target;
            input.value = null;

            if (selectedFile.type !== 'application/pdf') {
                showAlert('Por favor, selecione um arquivo PDF válido.', 'tempo', 'erro');
                return;
            }

            if (selectedFile.size > MAX_FILE_SIZE) {
                showAlert('O arquivo excede o tamanho máximo de 2 MB.', 'tempo', 'erro');
                return;
            }

            setFile(selectedFile);
            setConcessaoFile(selectedFile);

            if (selectedFile) {
                pushDataLayer('document_upload', {
                    file_type: 'carta_concessao',
                    file_name: selectedFile.name
                });

                extractTextFromPdf(selectedFile, 'concessao');
            }

        } catch (err) {

            showAlert('Erro ao processar o arquivo. Tente novamente.', 'tempo', 'erro');
        }

    };



    const handleRemoverArquivo = async (tipo) => {
        try {
            if (tipo === 'cnisFile') {
                setCnisFile(null);
                setFile(null);
                setAllTextCnis(null);
            } else if (tipo === 'concessaoFile') {
                setConcessaoFile(null);
                setFile(null);
                setAllTextCarta(null);
            }

            setExtraido(false);
            //showAlert('Arquivo removido com sucesso.', 'tempo', 'ok');
        } catch (err) {
            //console.error('Erro ao remover arquivo:', err);
            showAlert('Erro ao remover arquivo. Tente novamente.', 'tempo', 'erro');
        }
    };




    const nomeBateComTexto = (nomeCompleto, textoExtraido) => {

        if (!textoExtraido || !nomeCompleto) {
            setCurrentStep(0);
            localStorage.setItem("currentStep", "0");
            return
        }

        const nomeUpper = nomeCompleto.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const textoUpper = textoExtraido.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        // Verificação exata
        if (textoUpper.includes(nomeUpper)) return true;

        // Verificação flexível: nome e sobrenome principais
        const partesNome = nomeUpper.split(' ');
        const principais = partesNome.filter(n => n.length > 2).slice(0, 2); // evita "da", "de", etc.

        // Verifica se pelo menos 2 partes importantes do nome estão contidas
        const matchCount = principais.filter(parte => textoUpper.includes(parte)).length;
        return matchCount >= 2;
    };




    const extractTextFromPdf = async (file, uploadSource) => {

        if (!file) {
            setOutput('Por favor, selecione um arquivo PDF.');
            return;
        }

        //// console.log("UPLOADSOURCE: ", uploadSource);

        const fileReader = new FileReader();
        fileReader.onload = async (e) => {

            try {
                const pdfData = new Uint8Array(e.target.result);
                const pdf = await pdfjs.getDocument(pdfData).promise;
                const textPromises = [];

                for (let i = 1; i <= pdf.numPages; i++) {
                    textPromises.push(pdf.getPage(i).then(page => {
                        return page.getTextContent().then(textContent => {
                            return textContent.items.map(item => item.str).join(' ');
                        });
                    }));
                }

                const pagesText = await Promise.all(textPromises);
                const allText = pagesText.join('\n');



                if (uploadSource === 'cnis') {
                    // showAlert("VEIO DO CNIS");

                    if (!allText.includes("CNIS") || allText.includes("Extrato Ano Civil") || allText.includes("Código Emp./NB")) {
                        showAlert('Oops! Esse arquivo não parce ser um CNIS.', 'normal', 'erro');
                        return;
                    }


                    if (allText.includes("CNIS")) {
                        setCnisFile(file);
                    }



                    if (allText.includes("PRPPS")) {

                        setFormData((prevFormData) => ({
                            ...prevFormData,
                            funcionarioPublico: "SIM"
                        }));

                    }


                    //     //// console.log('TEXTO EXTRAÍDO DO CNIS: ', allText);

                }



                if (uploadSource === 'concessao') {
                    // showAlert("VEIO DA CARTA");
                    //// console.log('TEXTO EXTRAÍDO DA CARTA: ', allText);

                    if (!(allText.includes("Fator Previdenciário") || allText.includes("Coeficiente") || allText.includes("SALÁRIO") || allText.includes("Remunerações"))) {
                        showAlert('Oops! Sua carta não contém memória de cálculo.', 'normal', 'erro');
                        setConcessaoFile(null);
                        return;
                    }


                    if (!(
                        allText.includes("APOSENTADORIA POR IDADE") ||
                        allText.includes("APOSENTADORIA POR TEMPO DE CONTRIBUIÇÃO") ||
                        allText.includes("APOSENTADORIA POR TEMPO DE CONTRIBUICAO") ||
                        allText.includes("APOSENTADORIA ESPECIAL") ||
                        allText.includes("(42)") ||
                        allText.includes("APOSENT. TEMPO DE SERVICO DE PROFESSOR (57)") ||
                        allText.includes("APOSENTADORIA POR TEMPO DE SERVIÇO DO PROFESSOR") ||
                        allText.includes("Espécie:   41") ||
                        allText.includes("Espécie:   42") ||
                        allText.includes("Espécie:   46") ||
                        allText.includes("Espécie:   57")
                    )) {
                        showAlert('O tipo de aposentadoria precisa ser B-41, B-42, B-46 ou B-57.', 'normal', 'erro');
                        setConcessaoFile(null);
                        return;
                    }


                    let rmiRegex;
                    let rmiValue = "";


                    const dipRegex = /(?:requerido em|Início do pagamento|COM INÍCIO DO PAGAMENTO A PARTIR DE)\s*(\d{2}\/\d{2}\/\d{4})/;
                    const dipMatch = allText.match(dipRegex);


                    let dibRegex = /(?:vigência a partir de|Início do benefício|REQUERIDO EM)\s*(\d{2}\/\d{2}\/\d{4})/;
                    let dibMatch = allText.match(dibRegex);

                    if (!dibMatch) {
                        dibRegex = /^\s*(\d{2}\/\d{2}\/\d{4})(?=\s+Espécie)/;
                        dibMatch = allText.match(dibRegex);
                        //console.log("dibMatch", dibMatch);
                    }

                    let rmiMatch = null;




                    if (allText.includes("TITULAR")) {
                        const rmiRegex = /(NÚMERO DO BENEFÍCIO\s+(\d{3}\.\d{3}\.\d{3}-\d)\s+([\d\.]+,\d{2}))/;
                        rmiMatch = allText.match(rmiRegex);
                        rmiValue = rmiMatch ? rmiMatch[3] : '';
                    } else if (allText.includes("SAL. CORR.")) {
                        rmiRegex = /(?:COM RENDA MENSAL INICIAL DE|VALOR DO BENEFÍCIO\*)\s*R\$\s*([\d.,]+)/i;
                        rmiMatch = allText.match(rmiRegex);
                        rmiValue = rmiMatch ? rmiMatch[1] : '';
                    } else {
                        rmiRegex = /(?:renda mensal de|VALOR DO BENEFÍCIO\*)\s*R\$\s*([\d.,]+)/i;
                        rmiMatch = allText.match(rmiRegex);
                        rmiValue = rmiMatch ? rmiMatch[1] : '';
                    }



                    const dipDate = dipMatch ? dipMatch[1] : '';
                    const dibDate = dibMatch ? dibMatch[1] : '';





                    const rmiValueNumeric = parseFloat(rmiValue.replace(/[^\d,-]/g, '').replace(',', '.'));


                    if (dibDate && dadosCnis.length === 0) {
                        setDibParaCalc(dibDate);
                    }


                    ////console.log("chegou!!!!!!!!!!!", dibDate, dipDate, rmiValue);



                    const direitoAdquirido = (allText.includes("Direito Adquirido antes da EC 103/2019"));


                    setCartaData({
                        dip: dipDate,
                        dib: dibDate,
                        rmi: rmiValueNumeric,
                        direitoAdquirido: direitoAdquirido
                    });

                    // console.log('DIP extraído: ', dipDate);
                    // console.log('DIB extraído: ', dibDate);
                    // console.log('RMI extraído: ', rmiValue);


                    let dcbRegex;
                    let dcbMatch;
                    let dcbDate;



                    if (allText.includes("Data de Concessão do Benefício:")) {

                        dcbRegex = /Data de Concessão do Benefício:\s*(\d{2}\/\d{2}\/\d{4})/i;
                        dcbMatch = allText.match(dcbRegex);
                        dcbDate = dcbMatch ? dcbMatch[1] : '';

                    } else if (allText.includes("Concedido em")) {

                        dcbRegex = /Concedido em\s+(\d{2}\/\d{2}\/\d{4})\s+(\d{2}\/\d{2}\/\d{4})/i;
                        dcbMatch = allText.match(dcbRegex);
                        dcbDate = dcbMatch ? dcbMatch[2] : '';

                    } else {

                        dcbDate = dipDate;
                    }


                    setDcbDate(dcbDate);

                    ////console.log("DCB", dcbDate);


                    const dipDateSplit = new Date(
                        dcbDate.split('/').reverse().join('-')
                    );

                    const tenYearsFromDip = new Date(dipDateSplit);
                    tenYearsFromDip.setFullYear(tenYearsFromDip.getFullYear() + 10);

                    const now = new Date();

                    if (now > tenYearsFromDip) {
                        showAlert('Oops! Sua carta tem mais de 10 anos.', 'normal', 'erro');
                        setConcessaoFile(null);
                        return;
                    }




                    if (!(allText.includes("Carta de Concessão") || allText.includes("CARTA") || allText.includes("Forma de cálculo") || allText.includes("PODER JUDICIÁRIO"))) {
                        showAlert('Oops! Esse arquivo não parce ser uma CARTA DE CONCESSÃO.', 'normal', 'erro');
                        setConcessaoFile(null);
                        return;
                    }



                    if ((allText.includes("Carta de Concessão") || allText.includes("CARTA"))) {
                        setConcessaoFile(file);
                    }


                    let buscarSalarioMinimoDIB = buscarSalarioMinimoDIBCarta(dibDate);

                    if (rmiValueNumeric === buscarSalarioMinimoDIB) {
                        const userResponse = window.confirm("Detectamos que na data do início de seu benefício o valor da renda mensal inicial é igual ao salário mínimo. Deseja continuar?");

                        if (userResponse) {
                            // Ação para "Sim": fecha o alerta
                        } else {
                            // Ação para "Não": recarrega a página
                            showAlert("A sua revisão será encerrada.\nAgradecemos o acesso.", 'normal', 'erro')
                            setCurrentStep(0);
                            localStorage.setItem("currentStep", "0");
                            window.location.reload();
                        }
                    }


                    if (allText.includes("APOSENTADORIA POR TEMPO DE CONTRIBUIÇÃO") || allText.includes("(42)") || allText.includes("APOSENTADORIA POR TEMPO DE CONTRIBUICAO") || allText.includes("Espécie:   42")) {
                        showAlert('TIPO DE APOSENTADORIA: POR TEMPO DE CONTRIBUIÇÃO - B42.', 'tempo', 'ok');

                    } else if (allText.includes("APOSENTADORIA ESPECIAL") || allText.includes("Espécie:   46")) {
                        showAlert('TIPO DE APOSENTADORIA: ESPECIAL - B46.', 'tempo', 'ok');

                    } else if (allText.includes("APOSENTADORIA POR IDADE") || allText.includes("Espécie:   41")) {
                        showAlert('TIPO DE APOSENTADORIA: POR IDADE - B41.', 'tempo', 'ok');

                    } else if (allText.includes("APOSENT. TEMPO DE SERVICO DE PROFESSOR (57)") || allText.includes("APOSENTADORIA POR TEMPO DE SERVIÇO DO PROFESSOR") || allText.includes("Espécie:   57")) {
                        showAlert('TIPO DE APOSENTADORIA: PROFESSOR - B57.', 'tempo', 'ok');

                    } else {
                        showAlert('Nenhum tipo de aposentadoria encontrado.', 'tempo', 'erro');
                        setConcessaoFile(null);
                        return;
                    }


                }




                if (uploadSource === 'cnis') {
                    //  console.log("allTextCnis", allText);
                    setAllTextCnis(allText);

                } else if (uploadSource === 'concessao') {
                    setAllTextCarta(allText);
                }

                ////console.log("allTextCnis", allText);
            } catch (error) {
                //console.error('❌ Erro ao extrair texto do PDF:', error);
                showAlert('Erro ao processar o arquivo PDF. Tente novamente.', 'tempo', 'erro');
                if (uploadSource === 'cnis') setCnisFile(null);
                if (uploadSource === 'concessao') setConcessaoFile(null);
            }

        };

        fileReader.readAsArrayBuffer(file);
    };




    const processarAllText = async () => {
        //console.log("📂 Arquivos antes do envio:", allTextCarta, allTextCnis, cnisFile, concessaoFile, cartaData);

        if (!allTextCnis || !allTextCarta || !uid || !cnisFile || !concessaoFile || !cartaData) {
            console.warn('Dados incompletos para processar: allTextCnis, allTextCarta ou uid faltando');
            showAlert('Sessão expirada. Por favor, envie os arquivos novamente.');
            setCurrentStep(0);
            localStorage.setItem("currentStep", "0");
            console.warn('⚠️ Dados incompletos para processar:', {
                allTextCnis,
                allTextCarta,
                uid,
                cnisFile,
                concessaoFile,
                cartaData,
            });
            return;
        }

        // console.log("📂 Arquivos antes do envio:");
        // console.log("👉 cnisFile:", cnisFile, "type:", typeof cnisFile);
        // console.log("👉 concessaoFile:", concessaoFile, "type:", typeof concessaoFile);
        // console.log("📄 Outros campos:", { uid, allTextCartaLen: allTextCarta.length, allTextCnisLen: allTextCnis.length });

        if (allTextCnis && allTextCarta) {
            try {

                // console.log("entrou1", temPrpps, prppsRespondido);
                setLoading(true)

                // const formData = new FormData();
                // formData.append('cnisFile', cnisFile);
                // formData.append('concessaoFile', concessaoFile);
                // formData.append('cartaProp', allTextCarta);
                // formData.append('cnisProp', allTextCnis);
                // formData.append('cartaDataProp', JSON.stringify(cartaData));

                await auth.currentUser.reload();
                const idToken = await auth.currentUser.getIdToken(true);

                if (!idToken) {
                    return;
                }

                //console.log("dadosValidação", cnisFile, concessaoFile, cartaData, allTextCarta, allTextCnis );

                const body = {
                    cnisFile: await fileToBase64(cnisFile),
                    concessaoFile: await fileToBase64(concessaoFile),
                    cartaProp: allTextCarta,
                    cnisProp: allTextCnis,
                    cartaDataProp: cartaData,
                    nomeCompleto: formData.nomeCompleto
                };

                const response = await axios.post(`${baseURL}/mede`, body, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${idToken}`
                    }
                });


                // const response = await axios.post(`${baseURL}/extrair`, formData, {
                //     headers: {
                //         'Content-Type': 'multipart/form-data',
                //         'Authorization': `Bearer ${idToken}`,
                //     }
                // });

                const data = response.data;

                //console.log("data", data);
                console.log('Resultado da extração:', data.resultado);
                // console.log('data.temPrpps', data.resultado.temPrpps);

                if (data.resultado.temPrpps) {

                    setPrpps(data.resultado.dados);
                    setTemPrpps(data.resultado.temPrpps);
                    localStorage.setItem("temPrpps", "true");
                    localStorage.setItem("prppsRespondido", "false");
                    setDadosCnisCompletos(data.resultado.dadosParaAverbacao);
                    setDadosCnis(data.resultado.dadosParaAverbacao);
                    setDadosCarta(data.resultado.dadosCarta);
                    setCnis(data.resultado.dadosCnis);

                    //console.log("dados normal:", "setPrpps: ", data.resultado.dados, "setTemPrpps: ", data.resultado.temPrpps, "setDadosCnisCompleto: ", data.resultado.dadosParaAverbacao, "setCartaData: ", data.resultado.dadosCarta);

                    openModal();


                } else {

                    //console.log("dadosCnis", data.resultado.dados.dadosCnis, "dadosCarta", data.resultado.dados.dadosCarta);
                    setDadosCnis(data.resultado.dados.dadosCnis);
                    setDadosCarta(data.resultado.dados.dadosCarta);


                    let temRevisao = data.resultado.temRevisao;

                    setTemRevisao(temRevisao);
                    setExtraido(true);
                    setIsTestModalOpen(true);

                    //console.log("tem revisao?", data, data.resultado.temRevisao);

                }

                setOutput(JSON.stringify(data.resultado, null, 2));

                // console.log("entrou2", temPrpps, prppsRespondido);
                setLoading(false);

                return true;


            } catch (err) {

                //console.error('Erro na requisição:', err);
                setOutput('Erro ao conectar com o servidor.');
                showAlert('Ocorreu um erro ao salvar seus documentos. Por favor, faça o envio novamente antes de prosseguir para o pagamento.', 'tempo', 'erro');
                setCnisFile(null);
                setConcessaoFile(null);
                setDibParaCalc(null);
                setCartaData(null);
                setLoading(false);
                setTemPrpps(false);
                setCurrentStep(0);
                localStorage.setItem("currentStep", "0");
                setAllTextCnis(null);
                setAllTextCarta(null);

                try {
                    await axios.post(`${baseURL}/logs`, {
                        level: 'error',
                        message: `Erro ao buscar dados.`,
                        context: 'steps',
                        userId: uid || null,
                        stack: 'precessarAllText'
                    });
                } catch (logErr) {
                    console.warn('Falha ao enviar log para /logs:', logErr.message);
                }

                return false;


            }

        }
    };





    const obterSalarioMinimo = (data) => {
        if (!data || typeof data !== 'string' || !data.includes('/')) {
            console.warn('⚠️ Data inválida fornecida para obterSalarioMinimo:', data);
            return 0;
        }
        const [mes, ano] = data.split('/').map(Number);
        const salariosMinimos = {
            1994: { 7: 64.79, 8: 64.79, 9: 70, 10: 70, 11: 70, 12: 70 },
            1995: { 1: 70, 2: 70, 3: 70, 4: 70, 5: 100, 6: 100, 7: 100, 8: 100, 9: 100, 10: 100, 11: 100, 12: 100 },
            1996: { 1: 100, 2: 100, 3: 100, 4: 100, 5: 112, 6: 112, 7: 112, 8: 112, 9: 112, 10: 112, 11: 112, 12: 112 },
            1997: { 1: 112, 2: 112, 3: 112, 4: 112, 5: 120, 6: 120, 7: 120, 8: 120, 9: 120, 10: 120, 11: 120, 12: 120 },
            1998: { 1: 120, 2: 120, 3: 120, 4: 120, 5: 130, 6: 130, 7: 130, 8: 130, 9: 130, 10: 130, 11: 130, 12: 130 },
            1999: { 1: 130, 2: 130, 3: 130, 4: 130, 5: 136, 6: 136, 7: 136, 8: 136, 9: 136, 10: 136, 11: 136, 12: 136 },
            2000: { 1: 136, 2: 136, 3: 136, 4: 151, 5: 151, 6: 151, 7: 151, 8: 151, 9: 151, 10: 151, 11: 151, 12: 151 },
            2001: { 1: 151, 2: 151, 3: 151, 4: 180, 5: 180, 6: 180, 7: 180, 8: 180, 9: 180, 10: 180, 11: 180, 12: 180 },
            2002: { 1: 180, 2: 180, 3: 180, 4: 200, 5: 200, 6: 200, 7: 200, 8: 200, 9: 200, 10: 200, 11: 200, 12: 200 },
            2003: { 1: 200, 2: 200, 3: 200, 4: 240, 5: 240, 6: 240, 7: 240, 8: 240, 9: 240, 10: 240, 11: 240, 12: 240 },
            2004: { 1: 240, 2: 240, 3: 240, 4: 240, 5: 260, 6: 260, 7: 260, 8: 260, 9: 260, 10: 260, 11: 260, 12: 260 },
            2005: { 1: 260, 2: 260, 3: 260, 4: 260, 5: 300, 6: 300, 7: 300, 8: 300, 9: 300, 10: 300, 11: 300, 12: 300 },
            2006: { 1: 300, 2: 300, 3: 300, 4: 350, 5: 350, 6: 350, 7: 350, 8: 350, 9: 350, 10: 350, 11: 350, 12: 350 },
            2007: { 1: 350, 2: 350, 3: 350, 4: 380, 5: 380, 6: 380, 7: 380, 8: 380, 9: 380, 10: 380, 11: 380, 12: 380 },
            2008: { 1: 380, 2: 380, 3: 415, 4: 415, 5: 415, 6: 415, 7: 415, 8: 415, 9: 415, 10: 415, 11: 415, 12: 415 },
            2009: { 1: 415, 2: 465, 3: 465, 4: 465, 5: 465, 6: 465, 7: 465, 8: 465, 9: 465, 10: 465, 11: 465, 12: 465 },
            2010: { 1: 510, 2: 510, 3: 510, 4: 510, 5: 510, 6: 510, 7: 510, 8: 510, 9: 510, 10: 510, 11: 510, 12: 510 },
            2011: { 1: 540, 2: 540, 3: 545, 4: 545, 5: 545, 6: 545, 7: 545, 8: 545, 9: 545, 10: 545, 11: 545, 12: 545 },
            2012: { 1: 622, 2: 622, 3: 622, 4: 622, 5: 622, 6: 622, 7: 622, 8: 622, 9: 622, 10: 622, 11: 622, 12: 622 },
            2013: { 1: 678, 2: 678, 3: 678, 4: 678, 5: 678, 6: 678, 7: 678, 8: 678, 9: 678, 10: 678, 11: 678, 12: 678 },
            2014: { 1: 724, 2: 724, 3: 724, 4: 724, 5: 724, 6: 724, 7: 724, 8: 724, 9: 724, 10: 724, 11: 724, 12: 724 },
            2015: { 1: 788, 2: 788, 3: 788, 4: 788, 5: 788, 6: 788, 7: 788, 8: 788, 9: 788, 10: 788, 11: 788, 12: 788 },
            2016: { 1: 880, 2: 880, 3: 880, 4: 880, 5: 880, 6: 880, 7: 880, 8: 880, 9: 880, 10: 880, 11: 880, 12: 880 },
            2017: { 1: 937, 2: 937, 3: 937, 4: 937, 5: 937, 6: 937, 7: 937, 8: 937, 9: 937, 10: 937, 11: 937, 12: 937 },
            2018: { 1: 954, 2: 954, 3: 954, 4: 954, 5: 954, 6: 954, 7: 954, 8: 954, 9: 954, 10: 954, 11: 954, 12: 954 },
            2019: { 1: 998, 2: 998, 3: 998, 4: 998, 5: 998, 6: 998, 7: 998, 8: 998, 9: 998, 10: 998, 11: 998, 12: 998 },
            2020: { 1: 1039, 2: 1045, 3: 1045, 4: 1045, 5: 1045, 6: 1045, 7: 1045, 8: 1045, 9: 1045, 10: 1045, 11: 1045, 12: 1045 },
            2021: { 1: 1100, 2: 1100, 3: 1100, 4: 1100, 5: 1100, 6: 1100, 7: 1100, 8: 1100, 9: 1100, 10: 1100, 11: 1100, 12: 1100 },
            2022: { 1: 1212, 2: 1212, 3: 1212, 4: 1212, 5: 1212, 6: 1212, 7: 1212, 8: 1212, 9: 1212, 10: 1212, 11: 1212, 12: 1212 },
            2023: { 1: 1302, 2: 1302, 3: 1302, 4: 1302, 5: 1320, 6: 1320, 7: 1320, 8: 1320, 9: 1320, 10: 1320, 11: 1320, 12: 1320 },
            2024: { 1: 1412, 2: 1412, 3: 1412, 4: 1412, 5: 1412, 6: 1412, 7: 1412, 8: 1412, 9: 1412, 10: 1412, 11: 1412, 12: 1412 },
            2025: { 1: 1518, 2: 1518, 3: 1518, 4: 1518, 5: 1518, 6: 1518, 7: 1518, 8: 1518, 9: 1518, 10: 1518, 11: 1518, 12: 1518 }
        };

        const salario = salariosMinimos[ano] ? salariosMinimos[ano][mes] : 0;

        if (!salario) {
            console.warn(`⚠️ Salário mínimo não encontrado para ${mes}/${ano}`);
            return 0;
        }


        return salario;
    };



    const buscarSalarioMinimoDIBCarta = (dibDate) => {

        //console.warn('DIB:', dibDate);

        if (!dibDate || !dibDate.includes('/')) {
            //console.warn('⚠️ Data DIB inválida:', dibDate);
            return 0;
        }

        // Dividir a data e extrair o mês e o ano
        const [dia, mes, ano] = dibDate.split('/').map(Number);

        if (!mes || !ano || mes < 1 || mes > 12) {
            //console.warn('⚠️ Mês ou ano inválido em DIB:', dibDate);
            return 0;
        }

        // Criar uma constante "data" que só tenha mês e ano
        const data = `${mes.toString().padStart(2, '0')}/${ano}`;  // Exemplo: "12/2023"
        // Chamar a função obterSalarioMinimo para obter o valor do salário mínimo para o mês/ano da DIB
        const salarioMinimo = obterSalarioMinimo(data);

        //// console.log(`Salário mínimo para a DIB ${dibDate} é R$ ${salarioMinimo}`);
        return salarioMinimo;
    };



    ////////////////////////////////////////////////////////////



    const handleCheckboxChange = (e) => {
        const { checked } = e.target;
        setFormData({
            ...formData,
            aceitoTermos: checked,
        });
        setErrors({
            ...errors,
            aceitoTermos: false,
        });
    };


    const formatCPF = (cpf) => {
        return cpf
            .replace(/\D/g, '') // Remove todos os caracteres não numéricos
            .replace(/(\d{3})(\d{3})(\d{2})$/, '$1.$2-$3') // Formata o CPF como XXX.XXX.XXX-XX
            .replace(/(\d{3})(\d)/, '$1.$2'); // Adiciona o primeiro ponto
    };


    const formatCEP = (value) => {
        // Remove tudo que não for número
        value = value.replace(/\D/g, "");

        // Adiciona o traço no formato correto, se a string tiver o tamanho adequado
        if (value.length > 5) {
            return value.slice(0, 5) + "-" + value.slice(5, 8);
        }

        return value;
    };


    const formatVencimento = (value) => {
        const somenteNumeros = value.replace(/\D/g, '');

        if (somenteNumeros.length < 4) {
            return somenteNumeros;
        }

        const mes = somenteNumeros.substring(0, 2);
        const ano = somenteNumeros.substring(2, 4);
        return `${mes}/${ano}`;
    };


    const formatNumeroCartao = (value) => {

        const rawValue = value.replace(/\D/g, '');

        return rawValue.replace(/(\d{4})(?=\d)/g, '$1-');
    };


    /////////////////////////////////////////////////////////////////////
    const handleMetodoPagamentoChange = (e) => {
        const metodo = e.target.value;
        setMetodoPagamento(metodo);

    };





    function ordenarPorDataInicio(lista) {
        if (!Array.isArray(lista)) return [];

        return [...lista].sort((a, b) => {
            if (!a.data_inicio) return 1; // strings vazias vão para o final
            if (!b.data_inicio) return -1;

            const [diaA, mesA, anoA] = a.data_inicio.split('/');
            const [diaB, mesB, anoB] = b.data_inicio.split('/');

            const dataA = new Date(`${anoA}-${mesA}-${diaA}`);
            const dataB = new Date(`${anoB}-${mesB}-${diaB}`);

            return dataA - dataB; // crescente: mais antigo primeiro
        });
    };




    const validaDadosPagamento = async (api) => {
        //console.log("formData", formData);
        // Se o usuário estiver logado, pega dados do fichário, senão usa formData

        if (extraido === false || (temPrpps && !prppsRespondido)) {
            showAlert("Por favor, carregue os arquivos novamente.", "tempo", "erro");
            setCurrentStep(0);
            localStorage.setItem("currentStep", "0");
            return
        }


        const dadosParaValidar = {
            nomeCompleto: formData.nomeCompleto || fichario?.nomeCompleto || "",
            cpf: formData.cpf || fichario?.cpf || "",
            celular: formData.celular || fichario?.celular || "",
            cep: formData.cep || fichario?.cep || "",
            estado: formData.estado || fichario?.estado || "",
            cidade: formData.cidade || fichario?.cidade || "",
            bairro: formData.bairro || fichario?.bairro || "",
            rua: formData.rua || fichario?.rua || "",
            numero: formData.numero || fichario?.numero || "",
            nomeCompletoOutro: formData.nomeCompletoOutro || "",
            cpfOutro: formData.cpfOutro || "",
            cepOutro: formData.cepOutro || "",
            estadoOutro: formData.estadoOutro || "",
            cidadeOutro: formData.cidadeOutro || "",
            bairroOutro: formData.bairroOutro || fichario?.bairroOutro || "",
            ruaOutro: formData.ruaOutro || "",
            numeroOutro: formData.numeroOutro || "",
        };

        let newErrors = {
            nomeCompleto: dadosParaValidar.nomeCompleto === "" ? "*Obrigatório" : "",
            cpf: dadosParaValidar.cpf === ""
                ? "*Obrigatório"
                : dadosParaValidar.cpf.replace(/\D/g, '').length !== 11
                    ? "CPF inválido"
                    : "",
            celular: dadosParaValidar.celular === ""
                ? "*Obrigatório"
                : dadosParaValidar.celular.replace(/\D/g, '').length !== 11
                    ? "Celular inválido"
                    : "",
            cep: dadosParaValidar.cep === ""
                ? "*Obrigatório"
                : dadosParaValidar.cep.replace(/\D/g, '').length !== 8
                    ? "CEP inválido"
                    : "",
            estado: dadosParaValidar.estado === ""
                ? "*Obrigatório"
                : !estadosValidos.includes(dadosParaValidar.estado.toUpperCase())
                    ? "Estado inválido"
                    : "",
            cidade: dadosParaValidar.cidade === "" ? "*Obrigatório" : "",
            bairro: dadosParaValidar.bairro === "" ? "*Obrigatório" : "",
            rua: dadosParaValidar.rua === "" ? "*Obrigatório" : "",
            numero: dadosParaValidar.numero === "" ? "*Obrigatório" : "",
        };


        if (ccOutraPessoa && metodoPagamento === "cartao") {

            newErrors = {
                ...newErrors,
                nomeCompletoOutro: dadosParaValidar.nomeCompletoOutro === "" ? "*Obrigatório" : "",
                cpfOutro: dadosParaValidar.cpfOutro === ""
                    ? "*Obrigatório"
                    : dadosParaValidar.cpfOutro.replace(/\D/g, '').length !== 11
                        ? "CPF inválido"
                        : "",
                cepOutro: dadosParaValidar.cepOutro === ""
                    ? "*Obrigatório"
                    : dadosParaValidar.cepOutro.replace(/\D/g, '').length !== 8
                        ? "CEP inválido"
                        : "",
                estadoOutro: dadosParaValidar.estadoOutro === ""
                    ? "*Obrigatório"
                    : !estadosValidos.includes(dadosParaValidar.estadoOutro.toUpperCase())
                        ? "Estado inválido"
                        : "",
                cidadeOutro: dadosParaValidar.cidadeOutro === "" ? "*Obrigatório" : "",
                bairroOutro: dadosParaValidar.bairroOutro === "" ? "*Obrigatório" : "",
                ruaOutro: dadosParaValidar.ruaOutro === "" ? "*Obrigatório" : "",
                numeroOutro: dadosParaValidar.numeroOutro === "" ? "*Obrigatório" : "",
            };

        }

        setErrors(newErrors);
        setIsSubmitted(true);

        //console.log("Erros detectados:", newErrors);

        // Object.entries(newErrors).forEach(([campo, msg]) => {
        //     if(msg) console.warn(`Campo "${campo}" com problema: ${msg}`);
        // });


        if (Object.values(newErrors).some(msg => msg !== "") && metodoPagamento === "pix") {
            setMetodoPagamento();
        }

        if (Object.values(newErrors).some(msg => msg !== "")) {
            showAlert("Alguns campos estão incompletos ou incorretos. \nVerifique e tente novamente.", "tempo", "erro");
            return false
        };

        //console.log("Texto!", cartaTexto?.slice(0, 200), cnisTexto?.slice(0, 200), _carta, formData.nomeCompleto);

        // 1. Nome bate na Carta?
        //console.log("teste", formData.nomeCompleto, cartaTexto);

        if (!nomeBateComTexto(formData.nomeCompleto, allTextCarta)) {
            showAlert(
                '⚠️ O nome completo na Carta de Concessão parece diferente do informado. Verifique se está certo e tente novamente.',
                'normal',
                'erro'
            );
            return;
        }

        // 2. Nome bate no CNIS?
        if (!nomeBateComTexto(formData.nomeCompleto, allTextCnis)) {
            showAlert(
                '⚠️ O nome completo no CNIS parece diferente do informado. Verifique se está certo e tente novamente.',
                'normal',
                'erro'
            );
            return false;
        }

        // 3. CPF existe no CNIS?
        if (!allTextCnis.includes(formData.cpf)) {
            showAlert(
                'Oops! O CNIS não parece conter o CPF fornecido no cadastro. Por favor, verifique e tente novamente.',
                'normal',
                'erro'
            );
            return false;
        }


        if (currentUser?.uid && isFormDataDifferent(formData, fichario.user)) {
            const api = await axiosWithAuth();
            //console.log("api", Object.keys(api));
            if (!api) {
                return false
            }

            try {
                setLoading(true);
                const response = await api.post('/update-user', {
                    updateData: {
                        nomeCompleto: formData.nomeCompleto,
                        cpf: formData.cpf,
                        celular: formData.celular,
                        cep: formData.cep,
                        estado: formData.estado,
                        cidade: formData.cidade,
                        rua: formData.rua,
                        numero: formData.numero,
                        bairro: formData.bairro,
                        updatedAt: new Date().toISOString()
                    }
                });

                //console.log('✅ Dados atualizados no Firestore:', response.data);
                //await fetchFichario();
                setLoading(false);

            } catch (err) {
                //console.error('❌ Erro ao atualizar dados do usuário:', err);
                return false
            }

        }

        if (metodoPagamento === "cartao") {

            if (formData.nomeCartao.length < 1) {
                showAlert('O campo Nome não pode estar vazio.', 'tempo', 'erro');
                return false;
            }

            if (formData.nomeCartao.length < 3) {
                showAlert('Nome inválido', 'tempo', 'erro');
                return false;
            }

            if (formData.numeroCartao.length < 14) {
                showAlert('O cartão deve conter pelo menos 14 dígitos.', 'tempo', 'erro');
                return false;
            }

            if (formData.cvc.length < 3) {
                showAlert('O CVC deve conter 3 ou mais dígitos.', 'tempo', 'erro');
                return false;
            }

            if (formData.vencimento.length < 5) {
                showAlert('Vencimento inválido.', 'tempo', 'erro');
                return false;
            }

        }


        // return
        return true;


    }





    async function initBraspag(api) {
        try {
            // 1️⃣ Busca o token do seu backend
            const tokenResponse = await api.get("/3ds/mpi-token");

            // const data = await tokenResponse.json();
            // const token = data.token;

            const token = tokenResponse.data.token;
            //console.log("Token MPI:", token);

            // 2️⃣ Injeta o input do token
            let tokenInput = document.querySelector(".bpmpi_accesstoken");
            if (!tokenInput) {
                tokenInput = document.createElement("input");
                tokenInput.type = "hidden";
                tokenInput.className = "bpmpi_accesstoken";
                document.body.appendChild(tokenInput);
            }
            tokenInput.value = token;

            //   // 3️⃣ Injeta campos obrigatórios fixos para teste
            // const orderInput = document.querySelector(".bpmpi_ordernumber");
            // if (orderInput) orderInput.value = `PEDIDO-${Date.now()}`;
            let orderInput = document.querySelector(".bpmpi_ordernumber");
            if (!orderInput) {
                orderInput = document.createElement("input");
                orderInput.type = "hidden";
                orderInput.className = "bpmpi_ordernumber";
                orderInput.value = `PEDIDO-${Date.now()}`;
                document.body.appendChild(orderInput);
            } else {
                orderInput.value = `PEDIDO-${Date.now()}`;
            }


            // 🔧 Garante que o campo merchant_url está disponível antes do load()
            let merchantUrl = document.querySelector(".bpmpi_merchant_url");
            if (!merchantUrl) {
                merchantUrl = document.createElement("input");
                merchantUrl.type = "hidden";
                merchantUrl.className = "bpmpi_merchant_url";
                merchantUrl.value = `${merchant_URL}`;
                document.body.appendChild(merchantUrl);
            }



            // 4️⃣ Configura o ambiente Sandbox
            window.bpmpi_config = function () {
                return {
                    Debug: false,
                    Environment: `${mpi_env}`,
                    DFTimeout: 6000,
                };
            };


            //[...document.querySelectorAll('[class^="bpmpi_"]')].forEach(i => console.log(i.className, i.value || '⚠️ vazio'));


            // 5️⃣ Carrega o script Braspag
            if (!document.querySelector('script[src*="BP.Mpi.3ds20.min.js"]')) {
                const script = document.createElement("script");
                script.src = `${mpi_URL}`;
                script.async = true;
                script.onload = () => {
                    //console.log("✅ Script Braspag carregado");
                    if (window.BP && window.BP.Mpi) window.BP.Mpi.load();
                };
                document.body.appendChild(script);
            } else {
                //console.log("⚙️ Script Braspag já carregado, pulando...");
            }


        } catch (err) {
            console.error("Erro ao iniciar Braspag:", err);
        }
    };




    const limparLocalStorage = () => {
        const chaves = [
            "paymentToken", "authentication", "payer", "installments", "uid", "celular",
            "cidade", "estado", "bairro", "rua", "numero", "nomeCompleto", "cpf", "email",
            "cartaData", "dibParaCalc", "temPrpps", "cep"
        ];
        chaves.forEach(key => localStorage.removeItem(key));
    };

    const salvarLocalStorage = (pagamento) => {
        localStorage.setItem("paymentToken", pagamento.paymentToken);
        localStorage.setItem("authentication", JSON.stringify(pagamento.authentication));
        localStorage.setItem("payer", JSON.stringify(pagamento.payer));
        localStorage.setItem("installments", pagamento.installments);
        localStorage.setItem("uid", pagamento.uid);
        localStorage.setItem("celular", pagamento.celular);
        localStorage.setItem("cidade", pagamento.cidade);
        localStorage.setItem("estado", pagamento.estado);
        localStorage.setItem("bairro", pagamento.bairro);
        localStorage.setItem("rua", pagamento.rua);
        localStorage.setItem("numero", pagamento.numero);
        localStorage.setItem("nomeCompleto", pagamento.nomeCompleto);
        localStorage.setItem("cpf", pagamento.cpf);
        localStorage.setItem("email", pagamento.email);
        localStorage.setItem("cartaData", pagamento.cartaData || "");
        localStorage.setItem("dibParaCalc", pagamento.dibParaCalc || "");
        localStorage.setItem("temPrpps", pagamento.temPrpps ? "true" : "false");
        localStorage.setItem("cep", pagamento.cep);
    };




    const handlePagamento = async (e) => {
        e.preventDefault();


        // === AUTENTICAÇÃO DO USUÁRIO ===
        await auth.currentUser.reload();
        const idToken = await auth.currentUser.getIdToken(true);
        const api = await axiosWithAuth();

        if (!api) {
            return;
        }


        const valido = await validaDadosPagamento(api);
        if (!valido) return;


        setLoading(true);


        try {

            // 0. Obter o BIN

            let cardBrand = "unknown";
            let binInfo;

            try {
                const bin = formData.numeroCartao.slice(0, 6);

                //console.log("bin", formData.numeroCartao, bin);

                binInfo = await api.get(`/consulta-bin?bin=${bin}`);

                cardBrand = binInfo?.data?.brandName || "unknown";
                //console.log("🏷️ Bandeira identificada:", cardBrand);

            } catch (error) {
                console.warn("Erro ao consultar BIN:", error);
                showAlert("Não foi possível identificar a bandeira do cartão. Tente novamente", 'tempo', 'erro');
                //throw new Error("Erro ao consultar BIN");
            }

            // 1. Obter o AccessToken SOP
            const { data: { sopAccessToken } } = await api.get("/sop/access-token");


            //console.log("✅ Script SOP carregado!", sopAccessToken);

            // window.bpsilentOptions.debug = true;
            // window.bpsilentOptions.onDebug = console.log;


            // chamar tokenização
            if (window.bpSop_silentOrderPost) {


                try {

                    initBraspag(api);

                    const waitForCardinal = setInterval(() => {
                        if (window.Cardinal && window.bpmpi_authenticate) {
                            clearInterval(waitForCardinal);

                            //console.log("🎯 Cardinal pronto, iniciando bpmpi_authenticate...");

                            window.bpmpi_authenticate({

                                onSuccess: function (authResult) {

                                    //console.log("✅ Autenticação sucesso:", authResult);
                                    window.threeDSAuthResult = authResult;

                                },
                                onFailure: function (r) {
                                    console.warn("⚠️ Autenticação falhou:", r);
                                    window.threeDSAuthResult = null;
                                },
                                onUnenrolled: function (r) {
                                    console.info("ℹ️ Cartão não elegível:", r);
                                    window.threeDSAuthResult = null;
                                },
                                onError: function (e) {
                                    //console.error("❌ Erro na autenticação:", e);
                                    window.threeDSAuthResult = null;
                                    throw new Error("Erro na autenticação:", e);
                                },
                            });
                        }
                    }, 300);

                } catch (err) {

                    console.error("Erro ao buscar token MPI:", err);

                }



                window.bpSop_silentOrderPost({
                    accessToken: sopAccessToken,
                    environment: sop_env,
                    language: "pt",
                    cvvrequired: true,
                    enableBinQuery: false,
                    enableVerifyCard: true,
                    enableTokenize: false,
                    Authenticate: true,
                    provider: "braspag",

                    onSuccess: async (res) => {
                        //const paymentToken = res.PaymentToken || res.CardToken;
                        //console.log("✅ Tokenização bem-sucedida via SOP:", res);

                        const { PaymentToken, Authentication } = res;


                        // ⚠️ COMBINAR OS DADOS: SOP + autenticação 3DS (se existir)
                        const finalAuthentication = window.threeDSAuthResult
                            ? {
                                ...Authentication, // Dados do SOP
                                Cavv: window.threeDSAuthResult.Payment.ExtendedData.CAVV,
                                Xid: window.threeDSAuthResult.Payment.ExtendedData.XID,
                                Eci: window.threeDSAuthResult.Payment.ExtendedData.ECI,
                                ReferenceId: window.threeDSAuthResult.Payment.ExtendedData.ReferenceId,
                                Version: window.threeDSAuthResult.Payment.ExtendedData.Version
                            }
                            : Authentication; // Usar apenas dados do SOP se não houve 3DS


                        const isOutra = ccOutraPessoa === true;
                        const nome = isOutra ? formData.nomeCompletoOutro : formData.nomeCompleto;
                        const cpf = isOutra ? formData.cpfOutro : formData.cpf;
                        const cep = isOutra ? formData.cepOutro : formData.cep;
                        const estado = isOutra ? formData.estadoOutro : formData.estado;
                        const cidade = isOutra ? formData.cidadeOutro : formData.cidade;
                        const rua = isOutra ? formData.ruaOutro : formData.rua;
                        const numero = isOutra ? formData.numeroOutro : formData.numero;
                        const bairro = isOutra ? formData.bairroOutro : formData.bairro;

                        const pagamento = {
                            paymentToken: PaymentToken,
                            authentication: finalAuthentication,
                            installments: Number(formData.parcelas) || 1,
                            card_brand: binInfo.data.brandName,
                            payer: {
                                first_name: nome.split(" ")[0],
                                last_name: nome.split(" ").slice(1).join(" "),
                                email: formData.email,
                                identification: {
                                    type: "CPF",
                                    number: cpf.replace(/\D/g, "")
                                },
                                address: {
                                    zip_code: cep,
                                    street_name: rua,
                                    street_number: numero,
                                    neighborhood: bairro,
                                    city: cidade,
                                    federal_unit: estado
                                }
                            },
                            description: "Revisão de Aposentadoria"
                        };


                        const usuario = {
                            nomeCompleto: formData.nomeCompleto,
                            cpf: formData.cpf,
                            celular: formData.celular.replace(/\D/g, ''),
                            cep: formData.cep,
                            bairro: formData.bairro,
                            estado: formData.estado,
                            cidade: formData.cidade,
                            rua: formData.rua,
                            numero: formData.numero,
                            aposentadorias: formData.aposentadorias,
                            averbacoes: formData.averbacoes,
                            email: formData.email,
                            cartaData: cartaData || null,
                            dibParaCalc: dibParaCalc || null,
                            temPrpps: temPrpps || false
                        };

                        const formDataToSend = { pagamento, usuario };


                        // console.log("userpg", usuario);


                        //console.log("📦 Enviando pagamento e usuário ao backend...");

                        // 3.1 Enviar para backend para continuar (ZeroAuth, antifraude, transação final)
                        let response;

                        try {
                            response = await api.post("/card_payment", formDataToSend, {
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            });

                           // console.log("📨 Resposta do backend /card_payment:", response.status, response.data);


                        } catch (error) {
                            // console.error("❌ Erro detalhado na requisição /card_payment:");
                            // console.error("📦 Dados enviados:", JSON.stringify(formDataToSend, null, 2));
                            // console.error("🔍 Status do erro:", error.response?.status);
                            // console.error("📝 Mensagem do erro:", error.response?.data);
                            // console.error("🧩 Detalhes completos:", error);

                            showAlert(`${error.response?.data?.message || error.message}`, 'tempo', 'erro');
                            setLoading(false);
                            return;
                        }



                        //console.log("📨 Resposta do backend /card_payment:", response.status, response.data);

                        if (response.status === 200) {
                            showAlert("Pagamento realizado com sucesso!", 'tempo', 'ok');
                            localStorage.removeItem('currentStep');
                            localStorage.removeItem('currentStep');
                            limparLocalStorage();
                            navigate("/obrigado");
                            setLoading(false);

                        } else if (response.status === 202 && response.data.redirectUrl) {

                            salvarLocalStorage(pagamento);
                            window.location.href = response.data.redirectUrl;
                            return;

                        } else if (response.status === 400) {
                            showAlert("Pagamento abortado por falha no processamento.", 'tempo', 'ok');
                            limparLocalStorage();
                            setLoading(false);
                            return;

                        } else if (response.status === 402) {
                            showAlert("Pagamento negado pelo emiisor do cartão.", 'tempo', 'ok');
                            limparLocalStorage();
                            setLoading(false);
                            return;

                        } else if (response.status === 409) {
                            showAlert("Pagamento estornado.", 'tempo', 'ok');
                            limparLocalStorage();
                            setLoading(false);
                            return;

                        } else if (response.status === 410) {
                            showAlert("Pagamento cancelado antes da conclusão.", 'tempo', 'ok');
                            limparLocalStorage();
                            setLoading(false);
                            return;

                        } else if (response.status === 403) {
                            showAlert("Sessão expirada.\nEnvie seus documentos novamente.", 'tempo', 'erro');
                            setCurrentStep(0);
                            localStorage.setItem("currentStep", "0");
                            limparLocalStorage();
                            setLoading(false);
                            return;
                        }


                        else {

                            showAlert("Algo inesperado aconteceu: " + response.data.message, 'tempo', 'erro');
                            setLoading(false);

                        }

                    },


                    onError: (err) => {
                        //console.error("Erro ao gerar token via SOP no SCRIPT:", err);
                        showAlert("Erro ao processar o pagamento. Tente novamente.", 'tempo', 'erro');
                        setLoading(false);
                        //throw new Error("Erro ao gerar token via SOP no SCRIPT:", err);
                    },


                    onInvalid: (invalids) => {
                        console.warn("Dados inválidos no cartão:", invalids);
                        showAlert("Alguns dados do cartão estão incorretos. Verifique os dados e tente novamente.", 'tempo', 'erro');
                        setLoading(false);
                        //throw new Error("Dados inválidos no cartão:", invalids);
                    }
                });


            } else {
                console.error("SOP ainda não inicializou!");
                setLoading(false);
            }


        } catch (error) {
            //console.error("Erro no processo de pagamento:", error);
            showAlert("Erro ao finalizar o pedido. Tente novamente.", 'tempo', 'erro');
            setLoading(false);
        }


    };




    const handleQrCode = async () => {

        // === AUTENTICAÇÃO DO USUÁRIO ===
        await auth.currentUser.reload();
        const api = await axiosWithAuth();

        if (!api) {
            return;
        }

        const valido = await validaDadosPagamento(api);
        if (!valido) {
            setMetodoPagamento("");
            return;
        }

        handleQrCode2()
    }



    const handleQrCode2 = async () => {

        await auth.currentUser.reload();
        const idToken = await auth.currentUser.getIdToken(true);

        const usuario = {
            nomeCompleto: formData.nomeCompleto,
            cpf: formData.cpf,
            celular: formData.celular,
            cep: formData.cep,
            bairro: formData.bairro,
            estado: formData.estado,
            cidade: formData.cidade,
            rua: formData.rua,
            numero: formData.numero,
            aposentadorias: formData.aposentadorias,
            averbacoes: formData.averbacoes,
            email: formData.email,
            cartaData: cartaData || null,
            dibParaCalc: dibParaCalc || null,
            temPrpps: temPrpps || false
        };


        if (!usuario.nomeCompleto || !usuario.cpf || !usuario.email) {
            showAlert("Dados incompletos. Preencha todos os campos obrigatórios.", 'normal', 'erro');
            return;
        }



        const paymentData = {
            description: "Revisão de Aposentadoria",
            transaction_amount: 127.00,
            payment_method_id: "pix",
            payer: {
                email: usuario.email,
                first_name: usuario.nomeCompleto.split(" ")[0],
                last_name: usuario.nomeCompleto.split(" ").slice(1).join(" ") || "Sobrenome",
                identification: {
                    type: "CPF",
                    number: usuario.cpf
                }
            },
            "notification_url": `${baseURL}/webhook/mp`
        };




        const payload = {
            usuario,
            pagamento: paymentData
        };

        setLoading(true);
        try {


            const response = await fetch(`${baseURL}/pix`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });


            // console.log("RESPOSTA SERVIDOR:", response);

            if (response.status === 403) {
                showAlert("Sua sessão expirou. Por favor, reenvie os documentos.", 'normal', 'erro');
                setConcessaoFile(null);
                setCnisFile(null);
                setCurrentStep(0);
                localStorage.setItem("currentStep", "0");
                setPrpps([]);
                setTemPrpps(false);
                setPrppsRespondido(false);
                setRemoverPrpps([]);
                setRemoverPrppsAverba([]);
                setDadosParaAverbacao([]);
                setAposentou(false);
                setMetodoPagamento("");
                return;
            }

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData?.message || 'Erro ao gerar QR Code');
            }

            const data = await response.json();


            const expiracao = data?.expiracao;

            if (!expiracao) {
                throw new Error('Tempo de expiração não retornado pela API.');
            }

            setTempoExpiracao(new Date(expiracao));


            const qrCodeBase64 = data?.qr_code_base64;
            const copiaCola = data?.qr_code;
            const pixId = data?.compraId;


            if (!qrCodeBase64 || !pixId || !copiaCola) {
                throw new Error('QR Code, ID de pagamento ou Pix Copia e Cola não retornados corretamente.');
            }

            setQrCodeImage(`data:image/png;base64,${qrCodeBase64}`);
            setPaymentId(pixId);
            setQrCodeGerado(true);
            setCopiaColaPix(copiaCola);

            localStorage.setItem("pixPagamento", JSON.stringify({
                compraId: pixId,
                qrCodeBase64,
                copiaCola,
                expiracao
            }));

            //// console.log('QR Code Base64:', qrCodeString);
        } catch (error) {
            // console.error('Erro:', error);
            showAlert("Erro ao gerar o QR Code. Tente novamente.", 'tempo', 'erro');
            setQrCodeImage(null);
            setPaymentId(null);
            setMetodoPagamento("");
            setQrCodeGerado(false);

        } finally {

            setLoading(false);

        }

    };



    const resetPix = () => {
        setQrCodeGerado(false);
        setQrCodeImage('');
        setTempoExpiracao(null);
        setPaymentId(null);
        setCopiaColaPix("");
        localStorage.removeItem('pixPagamento');
        setMetodoPagamento("");
        showAlert("QR Code expirado. Gere um novo pagamento.", 'tempo', 'erro');
    };





    async function handleCheckPayment(paymentId) {
        setLoading(true);
        try {

            await auth.currentUser.reload();
            const idToken = await auth.currentUser.getIdToken(true);
            const response = await axios.post(`${baseURL}/pg_status`,
                { id_pg: paymentId },
                {
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${idToken}`,
                    },
                }
            );

            const data = response.data;

            if (data.success) {
                showAlert("Pagamento aprovado com sucesso!", "tempo", "ok");
                localStorage.removeItem("currentStep");
                navigate("/obrigado");
            } else {
                showAlert(
                    "Pagamento ainda não aprovado.",
                    "tempo",
                    "erro"
                );
            }
        } catch (err) {
            //console.error("Erro ao verificar pagamento:", err);
            showAlert("Erro ao verificar o pagamento. Tente novamente.", "tempo", "erro");

            try {
                await axios.post(`${baseURL}/logs`, {
                    level: "error",
                    message: `Erro ao buscar dados: `,
                    context: "steps",
                    userId: uid || null,
                    stack: "handleCheckPayment",
                });
            } catch (logErr) {
                console.warn("Falha ao enviar log para /logs:", logErr.message);
            }
        } finally {
            setLoading(false);
        }
    }




    const validatePasswordStrength = (password) => {
        const minLength = password.length >= 8;
        const hasUpper = /[A-Z]/.test(password);
        const hasLower = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecial = /[^A-Za-z0-9]/.test(password);

        return {
            minLength,
            hasUpper,
            hasLower,
            hasNumber,
            hasSpecial,
            isValid: minLength && hasUpper && hasLower && hasNumber && hasSpecial,
        };
    };





    const handleRegisterUser = async (e) => {



        // 1. Previne o recarregamento da página
        if (e && e.preventDefault) e.preventDefault();

        const { nomeCompleto, email, password, celular, aceitoTermos } = formData;

        // 2. Cria um objeto com os resultados de todas as validações
        const validationErrors = {
            nomeCompleto: !nomeCompleto ? "*Obrigatório" : "",
            email: !email ? "*E-mail obrigatório" : "",
            celular: !celular ? "*Celular obrigatório" : "",
            password: !password ? "*Senha obrigatória" : "",
            aceitoTermos: !aceitoTermos // true se não estiver marcado
        };

        // 3. Atualiza o estado de erros e marca como submetido
        setErrors(validationErrors);
        setIsSubmitted(true);

        // 4. Verifica se existe erro
        const hasErrors = Object.values(validationErrors).some(error =>
            (typeof error === 'string' && error !== "") || error === true
        );

        if (hasErrors) {
            return; // Para aqui se houver erro
        }

        const passwordCheck = validatePasswordStrength(password);
        if (!passwordCheck.isValid) {
            showAlert(
                "A senha deve ter pelo menos 8 caracteres, incluir letra maiúscula, letra minúscula, número e caractere especial.",
                "tempo",
                "erro"
            );
            return;
        }


        setLoading(true);

        try {
            // console.log("[handleRegisterUser] Enviando request para backend...");
            const response = await fetch(`${baseURL}/user/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nomeCompleto,
                    email,
                    password,
                    celular
                }),
            });

            const data = await response.json();
            // console.log("[handleRegisterUser] Resposta do backend:", data);

            if (!response.ok) {
                if (data.errors) {
                    const mensagens = Object.values(data.errors).join('\n');
                    showAlert(`Erro(s):\n${mensagens}`);
                    //console.error("[handleRegisterUser] Backend retornou erros:", data.errors);
                } else if (data.alreadyExists && data.passwordValid === false) {
                    showAlert('Já existe um usuário com esse e-mail. Faça o login ou use outro e-mail.');
                    console.warn("[handleRegisterUser] Usuário já existe, senha inválida");
                } else {
                    showAlert(`${data.message || 'Erro desconhecido.'}`);
                    //console.error("[handleRegisterUser] Erro desconhecido:", data);
                }
                return;
            }

            // console.log("[handleRegisterUser] Usuário criado no Auth + Firestore com sucesso, iniciando login técnico...");
            try {
                auth.languageCode = "pt-BR";
                const userCred = await signInWithEmailAndPassword(auth, email, password);
                // console.log("[handleRegisterUser] Login técnico bem-sucedido, UID:", userCred.user.uid);

                if (!userCred.user.emailVerified) {
                    console.warn("[handleRegisterUser] E-mail ainda NÃO verificado. Disparando sendEmailVerification...");
                    await sendEmailVerification(userCred.user);
                    showAlert(
                        'Enviamos um link de confirmação para seu WhatsApp e e-mail.',
                        'normal',
                        'sucesso'
                    );
                    // console.log("[handleRegisterUser] E-mail de verificação enviado para:", userCred.user.email);
                    return;
                }

                // console.log("[handleRegisterUser] E-mail já estava verificado. Seguindo para próxima etapa.");
                handleNext();

            } catch (loginErr) {
                //console.error("[handleRegisterUser] Erro ao logar após cadastro:", loginErr);
                showAlert('Conta criada, mas erro ao fazer login automático.');
            }

        } catch (error) {
            //console.error("[handleRegisterUser] Erro ao criar usuário:", error);
            showAlert(`Erro: ${error.message}`);
            try {
                await axios.post(`${baseURL}/logs`, {
                    level: 'error',
                    message: `Erro ao criar usuário`,
                    context: 'steps',
                    userId: uid || null,
                    stack: 'handleRegisterUser',
                    error: error.message,
                });
            } catch (logErr) {
                console.warn("[handleRegisterUser] Falha ao enviar log para /logs:", logErr.message);
            }
        } finally {
            setLoading(false);
        }
    };






    const handleRecuperarSenha = () => {
        if (!currentUser.email) {
            showAlert("Digite o e-mail para recuperar a senha.", "tempo", "erro");
            return;
        }

        sendPasswordResetEmail(auth, currentUser.email)
            .then(() => {
                showAlert("E-mail de recuperação enviado!", "tempo", "ok");
            })
            .catch(error => {
                console.error("Erro ao enviar e-mail de recuperação:", error);
                showAlert("Erro ao enviar e-mail de recuperação. Verifique o e-mail digitado.", "tempo", "erro");
            });
    };









    const formatTime = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };



    const handleReenviarWhats = async () => {
        if (cooldownWhats > 0) return;

        try {
            // === AUTENTICAÇÃO DO USUÁRIO ===
            await auth.currentUser.reload();
            const api = await axiosWithAuth();

            if (!api) return;

            const res = await api.post("/auth/reenviar-msg", {
                email: formData.email,
                telefone: formData.celular,
            });

            if (res.data?.success) {
                showAlert("Mensagem reenviada! Verifique seu WhatsApp.", "tempo", "ok");
                startCooldown("whats", 5 * 60);
            } else {
                throw new Error(res.data?.message || "Falha ao reenviar link.");
            }
        } catch (err) {
            //console.error("[handleReenviarWhats] Erro:", err);
            showAlert("Erro ao reenviar o link. Tente novamente mais tarde.", "tempo", "erro");
        }
    };





    const handleReenviarEmail = async () => {

        if (cooldown > 0) return;

        try {
            if (currentUser) {
                await sendEmailVerification(currentUser);
                showAlert("E-mail de verificação reenviado! Verifique sua caixa de entrada.", "tempo", "ok");
                startCooldown("email", 60);
            }
        } catch (error) {
            //console.error("Erro ao reenviar email:", error);
            showAlert("Erro ao reenviar o e-mail. Tente novamente mais tarde.", "tempo", "erro");
        }

    };




    const handleCcOutraPessoa = () => {

        setCcOutraPessoa(prev => !prev);

    }




    if (emailVerified === null) {
        return <p>Carregando...</p>;
    }


    var env = getQueryString("env");

    function bpmpi_config() {
        return {
            onReady: function () {
                // Evento indicando quando a inicialização do script terminou.
                document.getElementById("btnSendOrder").disabled = false;
            },
            onSuccess: function (e) {
                // Cartão elegível para autenticação, e portador autenticou com sucesso.
                var cavv = e.Cavv;
                var xid = e.Xid;
                var eci = e.Eci;
                var version = e.Version;
                var referenceId = e.ReferenceId;
            },
            onFailure: function (e) {
                // Cartão elegível para autenticação, porém o portador finalizou com falha.
                var xid = e.Xid;
                var eci = e.Eci;
                var version = e.Version;
                var referenceId = e.ReferenceId;
            },
            onUnenrolled: function (e) {
                // Cartão não elegível para autenticação (não autenticável).
                var xid = e.Xid;
                var eci = e.Eci;
                var version = e.Version;
                var referenceId = e.ReferenceId;
            },
            onDisabled: function () {
                // Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
            },
            onError: function (e) {
                // Erro no processo de autenticação.
                var xid = e.Xid;
                var eci = e.Eci;
                var returnCode = e.ReturnCode;
                var returnMessage = e.ReturnMessage;
                var referenceId = e.ReferenceId;
            },
            onUnsupportedBrand: function (e) {
                // Bandeira não suportada para autenticação.
                var returnCode = e.ReturnCode;
                var returnMessage = e.ReturnMessage;
            },
            Environment: env ? env : "SDB",
            Debug: true,
        };
    }

    function getQueryString(field) {
        var href = window.location.href;
        var reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
        var string = reg.exec(href);
        return string ? string[1] : null;
    }



    return (

        <div className="validadores">


            {/* ARQUIVOS */}
            {currentStep === 0 && (
                <div className="arquivos">

                    <div>
                        <Modal isOpen={isModalOpen} onClose={closeModal} ref={modalContentRef}>
                            <div className='prpps-modal'>
                            <h2 style={{ color: 'red' }}><u>ATENÇÃO!</u></h2>

                            <h2 style={{ color: 'red' }}><u>CALMA, RESPONDA DEVAGAR, VOCÊ TEM TEMPO!</u></h2>

                            {currentStepPrpps === 0 && (

                                <div className='top-margin'>
                                    <p>Indentificamos vínculos de <strong>Serviço Público</strong>.</p>
                                    <p className='small-top-margin'>Informe se <strong>pretende se aposentar ou já se aposentou como funcionário público</strong> em algum dos órgãos abaixo:</p>
                                    <table className='medium-top-margin'>
                                        <thead>
                                            <tr>
                                                <th>Vínculo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {prpps.map((vinculo, index) => (
                                                <tr key={index}>
                                                    <td className='prpps-table'>
                                                        <h5>{vinculo.vinculo}</h5>
                                                        <p className='prpps-datas'>{vinculo.data_inicio} - {vinculo.data_fim}</p>
                                                        <div className='prpps-perguntas'>
                                                            <div className='prpps-opcoes'>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name={`aposentado${index}`}
                                                                        value="sim"
                                                                        disabled={removerPrpps.length >= 2 && !removerPrpps.includes(vinculo)}
                                                                        // checked={removerPrpps.includes(vinculo)}
                                                                        onChange={() => handleAposentadoChange(vinculo, "sim")}
                                                                    />{" "}
                                                                    Sim
                                                                </label>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name={`aposentado${index}`}
                                                                        value="nao"
                                                                        // checked={!removerPrpps.includes(vinculo)}
                                                                        onChange={() => handleAposentadoChange(vinculo, "nao")}
                                                                    />{" "}
                                                                    Não
                                                                </label>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <button className='top-margin' onClick={handleConfirmAposentadoria}>
                                        Confirmar
                                    </button>
                                </div>
                            )}


                            {currentStepPrpps === 1 && (
                                <div>
                                    <p className='small-top-margin'>Informe se <strong>averbou</strong> algum dos órgãos abaixo:</p>

                                    <table className='top-margin'>
                                        <thead>
                                            <tr>
                                                <th>Vínculo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dadosParaAverbacao.map((vinculo, index) => (
                                                <tr key={index}>
                                                    <td className='prpps-table'>
                                                        <h5>{vinculo.vinculo}</h5>
                                                        <p className='prpps-datas'>{vinculo.data_inicio} - {vinculo.data_fim}</p>
                                                        <div className='prpps-perguntas'>
                                                            <div className='prpps-opcoes'>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name={`aposentado${index}`}
                                                                        value="sim"
                                                                        // checked={removerPrppsAverba.includes(vinculo)}
                                                                        onChange={() => handleAverbacaoChange(vinculo, "sim")}
                                                                    />{" "}
                                                                    Sim
                                                                </label>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name={`aposentado${index}`}
                                                                        value="nao"
                                                                        // checked={!removerPrppsAverba.includes(vinculo)}
                                                                        onChange={() => handleAverbacaoChange(vinculo, "nao")}
                                                                    />{" "}
                                                                    Não
                                                                </label>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>


                                    <div className='row'>
                                        {/* <button className='top-margin' onClick={handlePreviusPrpps}>
                                        Voltar
                                    </button> */}
                                        <button className='top-margin' onClick={handleConfirmAverbacao}>
                                            Confirmar
                                        </button>
                                    </div>
                                </div>
                            )}

                            </div>

                        </Modal>
                    </div>


                    <div className={`destinatario gap ${!currentUser ? 'login-overlay' : ''}`}>

                        {currentUser ? (
                            !emailVerified ? (
                                /* CENÁRIO: LOGADO E NÃO VERIFICADO */
                                <div className='center'>

                                    <div className='center'>
                                        <div className='file-title'>
                                            <p className='secText bold'>DESTINATÁRIO</p>
                                        </div>
                                    </div>

                                    <div className='arquivos-infos-container'>
                                        <div className='arquivos-infos-box'>
                                            <p className='top-margin'>E-mail: <strong>{currentUser.email}</strong></p>
                                            <a type="button" className="recuperar-senha" onClick={handleRecuperarSenha}>
                                                Alterar minha senha
                                            </a>

                                            {/* Como já estamos dentro da condicional !emailVerified, removemos a checagem redundante aqui */}
                                            <div className='email-verify'>
                                                <p className="top-margin bold">Clique no link de verificação que enviamos para o <br></br>WhatsApp/E-mail cadastrado:</p>
                                                <button className="" onClick={handleCheckUser}>Já verifiquei minha conta</button>


                                                <div className='recuperar-senha-container top-margin'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="" viewBox="0 0 16 16">
                                                        <path d="M13.601 2.326A7.854 7.854 0 0 0 8.002 0C3.584 0 .002 3.582.002 8a7.96 7.96 0 0 0 1.062 4.002L0 16l4.115-1.042A7.967 7.967 0 0 0 8 16c4.418 0 8-3.582 8-8a7.95 7.95 0 0 0-2.399-5.674ZM8 14.5a6.502 6.502 0 0 1-3.313-.888l-.237-.138-2.434.617.649-2.378-.153-.244A6.487 6.487 0 0 1 1.5 8c0-3.584 2.916-6.5 6.5-6.5a6.48 6.48 0 0 1 4.6 1.9A6.48 6.48 0 0 1 14.5 8c0 3.584-2.916 6.5-6.5 6.5Zm3.034-4.326c-.165-.083-.975-.48-1.127-.536-.151-.057-.262-.083-.373.083s-.43.536-.528.648c-.097.11-.195.125-.36.042-.165-.083-.7-.258-1.332-.822a5.034 5.034 0 0 1-.933-1.154c-.098-.165-.01-.255.073-.338.075-.074.165-.194.248-.292.083-.097.11-.166.165-.277.056-.111.028-.208-.014-.292-.042-.083-.373-.896-.512-1.227-.135-.326-.273-.282-.373-.287h-.32a.617.617 0 0 0-.445.208c-.152.166-.582.568-.582 1.385 0 .817.597 1.604.68 1.714.083.11 1.174 1.792 2.847 2.51 1.67.716 1.67.478 1.97.45.3-.027.975-.397 1.11-.782.138-.388.138-.72.097-.782-.04-.062-.15-.097-.315-.18Z" />
                                                    </svg>
                                                    <a className="recuperar-senha" onClick={handleReenviarWhats} disabled={cooldownWhats > 0}>
                                                        {cooldownWhats > 0 ? (
                                                            <>
                                                                Aguarde{" "}
                                                                <span className="cooldown-timer">
                                                                    {formatTime(cooldownWhats)}
                                                                </span>
                                                            </>
                                                        ) : (
                                                            "Reenviar link por WhatsApp"
                                                        )}
                                                    </a>
                                                </div>


                                                <div className='recuperar-senha-container top-margin'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="" viewBox="0 0 16 16">
                                                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-.5a.5.5 0 0 0-.5.5v.217l6.5 3.905 6.5-3.905V4a.5.5 0 0 0-.5-.5H2ZM14 6.383l-5.803 3.486a.5.5 0 0 1-.394 0L2 6.383V12a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V6.383Z" />
                                                    </svg>
                                                    <a
                                                        className="recuperar-senha"
                                                        onClick={handleReenviarEmail}
                                                        disabled={cooldown > 0}
                                                    >
                                                        {cooldown > 0 ? (
                                                            <>
                                                                Aguarde{" "}
                                                                <span className='cooldown-timer'>
                                                                    {formatTime(cooldown)}
                                                                </span>
                                                            </>
                                                        ) : (
                                                            "Reenviar link por E-mail"
                                                        )}
                                                    </a>
                                                </div>

                                                <button type="button" className="top-margin" onClick={handleNavigate}>
                                                    Voltar
                                                </button>

                                            </div>
                                        </div>
                                    </div>


                                </div>
                            ) : (
                                /* CENÁRIO: LOGADO E VERIFICADO -> NÃO MOSTRA NADA */
                                null
                            )

                        ) : (
                            /* CENÁRIO: NÃO LOGADO (!currentUser) -> MOSTRA LOGIN/CADASTRO */
                            !modoLogin ? (

                                <form>

                                    <img className="user-logo login" src="/assets/userIcon.svg" alt=""></img>

                                    <div className="loginFormBox login-container">

                                        <div className='chat-toggle row flex-end'>
                                            <div class="login-toggle">
                                                <img src="/assets/close.svg" alt="Fechar" onClick={handleNavigate}></img>
                                            </div>
                                        </div>


                                        <div className='top-margin'>
                                            <h3>BEM-VINDO!</h3>
                                            <p>Faça o cadastro para continuar</p>
                                        </div>

                                        <div className="input-container top-margin">
                                            <label className="small-top-margin">NOME COMPLETO</label>
                                            <input
                                                type="text"
                                                name="nomeCompleto"
                                                id="nomeCompleto"
                                                placeholder="Nome completo"
                                                value={formData.nomeCompleto}
                                                onChange={handleInputChange}
                                                maxLength={40}
                                                className={errors.nomeCompleto ? "error" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.nomeCompleto && (
                                                    <span>{errors.nomeCompleto}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="input-container">
                                            <label>WHATSAPP</label>
                                            <input
                                                type="text"
                                                name="celular"
                                                id="celular-login"
                                                placeholder="Celular com DDD"
                                                value={formData.celular}
                                                onChange={handleInputChange}
                                                maxLength={14}
                                                className={errors.celular ? "error celular-login" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.celular && (
                                                    <span>{errors.celular}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="input-container">
                                            <label>E-MAIL</label>
                                            <input
                                                id="email"
                                                type="email"
                                                name="email"
                                                placeholder="E-mail"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                className={errors.email ? "error" : ""}
                                                autoComplete="email"
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.email && (
                                                    <span>{errors.email}</span>
                                                )}
                                            </div>
                                        </div>


                                        <div className="input-container">
                                            <label>SENHA</label>
                                            <div className='password-container row login'>
                                                <input
                                                    id="password"
                                                    type={showPassword ? 'text' : 'password'}
                                                    name="password"
                                                    placeholder="Senha"
                                                    value={formData.password}
                                                    onChange={handleInputChange}
                                                    className={errors.password ? "error" : ""}
                                                    autoComplete="new-password"
                                                />
                                                <span className='eye-icon' onClick={() => setShowPassword(!showPassword)}>
                                                    {showPassword ? (<img className="eyeSlash" src="/assets/eyeSlash.svg" alt="Ícone de olho fechado" />) : (<img className="eye" src="/assets/eye.svg" alt="Ícone de olho aberto" />)}
                                                </span>
                                            </div>

                                            {formData.password && (
                                                <ul className="password-checklist">
                                                    <li className={validatePasswordStrength(formData.password).hasLower ? "valid" : "invalid"}>
                                                        <span className="icon">
                                                            {validatePasswordStrength(formData.password).hasLower ? "✔" : "✖"}
                                                        </span>
                                                        Letra minúscula
                                                    </li>
                                                    <li className={validatePasswordStrength(formData.password).hasUpper ? "valid" : "invalid"}>
                                                        <span className="icon">
                                                            {validatePasswordStrength(formData.password).hasUpper ? "✔" : "✖"}
                                                        </span>
                                                        Letra maiúscula
                                                    </li>
                                                    <li className={validatePasswordStrength(formData.password).hasNumber ? "valid" : "invalid"}>
                                                        <span className="icon">
                                                            {validatePasswordStrength(formData.password).hasNumber ? "✔" : "✖"}
                                                        </span>
                                                        Número
                                                    </li>
                                                    <li className={validatePasswordStrength(formData.password).hasSpecial ? "valid" : "invalid"}>
                                                        <span className="icon">
                                                            {validatePasswordStrength(formData.password).hasSpecial ? "✔" : "✖"}
                                                        </span>
                                                        Caractere especial
                                                    </li>
                                                    <li className={validatePasswordStrength(formData.password).minLength ? "valid" : "invalid"}>
                                                        <span className="icon">
                                                            {validatePasswordStrength(formData.password).minLength ? "✔" : "✖"}
                                                        </span>
                                                        Mínimo 8 caracteres
                                                    </li>
                                                </ul>
                                            )}
                                            <div className="error-message">
                                                {isSubmitted && errors.password && (
                                                    <span>*Obrigatório</span>
                                                )}
                                            </div>
                                        </div>


                                        <div className="aceito-termos">
                                            <div className="checkbox-container">
                                                <input
                                                    id="aceitoTermos"
                                                    type="checkbox"
                                                    name="aceitoTermos"
                                                    checked={formData.aceitoTermos}
                                                    onChange={handleCheckboxChange}
                                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                                />
                                                <label htmlFor="aceitoTermos">



                                                    Ao contratar este serviço confirmo que estou de acordo com os
                                                    <a
                                                        href="/termos"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ marginLeft: '5px', textDecoration: 'underline', color: 'blue' }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        termos e condições
                                                    </a>

                                                </label>
                                            </div>

                                            {/* 
                                                <div className="error-message top-margin">
                                                    {isSubmitted && errors.aceitoTermos && (
                                                        <span className="error-message">*Você precisa aceitar os termos para finalizar.</span>
                                                    )}
                                                </div> */}

                                            <div
                                                className="error-message small-top-margin"
                                                style={{ display: (isSubmitted && errors.aceitoTermos) ? 'block' : 'none' }}
                                            >
                                                <span className="error-message">*Você precisa aceitar os termos para continuar.</span>
                                            </div>

                                        </div>

                                        <button id="login-buttons" type="submit" onClick={(e) => handleRegisterUser(e)} className="button loginButton top-margin">
                                            Continuar teste grátis
                                        </button>


                                        <div>
                                            <p className='underline top-margin' style={{ cursor: "pointer" }} onClick={() => setModoLogin(true)}>
                                                Já tenho uma conta
                                            </p>
                                        </div>

                                    </div>

                                </form>

                            ) : (

                                <div>

                                    <Login>
                                        <p
                                            className='underline small-top-margin'
                                            style={{ cursor: "pointer", marginTop: '10px' }}
                                            onClick={() => setModoLogin(false)}
                                        >
                                            Cadastro
                                        </p>
                                    </Login>

                                </div>
                            )
                        )}

                    </div>


                    {emailVerified && (
                        <div>

                            {extraido && (!temPrpps || temPrpps && prppsRespondido) ? (

                                <div>
                                    {temRevisao ? (

                                        <Modal isOpen={isTestModalOpen} onClose={closeModal} ref={modalContentRef}>
                                            <div className='atencao-rev-pisitiva'>
                                                <h3 className=''>ATENÇÃO!</h3>
                                            </div>
                                            <div className='free-test-box'>
                                                <h3 className='top-margin'>RESULTADO POSITIVO<br></br>PARA REVISÃO!</h3>
                                                <h4 className='top-margin'><strong><u>Efeitos financeiros positivos!</u></strong></h4>

                                                <p>Você receberá em seu nome:</p>

                                                <ul id="info-docs">
                                                    <p>- <strong>Relatório</strong>, com relação de todos os erros encontrados e as respectivas provas. <a href="https://www.youtube.com/shorts/hbM6gEpIJ3c" target="_blank" rel="noopener noreferrer" onClick={() => {
                                                        pushDataLayer('ver_mais', {
                                                            current_step: 0,
                                                            next_step: 1,
                                                            step_name: 'teste-gratis'
                                                        });
                                                    }}><u>Ver</u></a></p>
                                                    <p className=''>- <strong>Requerimento</strong> de revisão de cálculos já pronto para ser entregue ao INSS. <a href="https://www.youtube.com/shorts/mof3rDOe5eI?t=13&feature=share"  target="_blank" rel="noopener noreferrer" onClick={() => {
                                                        pushDataLayer('ver_mais', {
                                                            current_step: 0,
                                                            next_step: 1,
                                                            step_name: 'teste-gratis'
                                                        });
                                                    }}><u>Ver</u></a></p>
                                                </ul>

                                                <div className='center'>
                                                    <button id="confirm-test" className="" type="submit" onClick={handleNext}>
                                                        Acessar resultado detalhado
                                                    </button>
                                                </div>

                                                <p className='top-margin valores-teste'><strong>R$ 312,00</strong> em <span className="light-bold">6x s/ juros no cartão</span> ou no Pix</p>

                                                <div className='top-margin'>
                                                    <a style={{ cursor: 'pointer' }} onClick={closeTestModal}><u>Voltar mais tarde</u></a>
                                                </div>

                                            </div>
                                        </Modal>

                                    ) : (

                                        <Modal isOpen={isTestModalOpen} onClose={closeModal} ref={modalContentRef}>
                                                <div className='atencao-rev-pisitiva'>
                                                    <h3 className=''>ATENÇÃO!</h3>
                                                </div>
                                            <div className='free-test-box teste-sem-revisao'>
                                                <h3 className='top-margin dark-green-underline'>NÃO TEM DIREITO A REVISÃO DE CÁLCULOS!</h3>
                                                <p className="medium-top-margin">Diante da análise da Carta de Concessão e do CNIS, não foram verificados erros ou, quando existentes, estes não justificam o pedido de revisão, baixo efeito financeiro.</p>
                                                <p className='top-margin'>Gratos pela sua consulta!</p>
                                                <div className='center top-margin'>
                                                    <button id="confirm-test" className="top-margin" type="button" onClick={closeTestModal}>
                                                        Finalizar teste
                                                    </button>
                                                </div>
                                                <div className="top-margin">
                                                    <a onClick={handleNext}>
                                                        <u>Ainda quero continuar com a revisão</u>
                                                    </a>
                                                </div>
                                            </div>
                                        </Modal>

                                    )}

                                </div>


                            ) : (

                                <></>
                            )}




                            <div>
                                <div className='center'>
                                    <div className='file-title'>
                                        <p className='secText bold'>ARQUIVOS</p>
                                    </div>
                                </div>

                                <div className='arquivos-infos-container'>
                                    <div className='arquivos-infos-box'>
                                        <p className='light-bold'>ANEXE OS SEGUINTES ARQUIVOS:</p>
                                        <ul>
                                            <li className="numUm">
                                                <img className='numUm-icon' width="22" height="22" src="/assets/numero_um.svg" alt="Ícone arquivo em pdf" />
                                                <a href="https://youtube.com/shorts/2CLs1Q4184E" target="_blank" rel="noopener noreferrer"><p>CNIS - PDF migrado do Meu INSS.</p></a>
                                                <a
                                                    className=""
                                                    href="https://youtube.com/shorts/2CLs1Q4184E"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <p className='no-bottom-margin dark-green-underline no-gap saiba-como'>
                                                        <img width="12" src="/assets/interrogacao_icon.svg" alt="Ícone de interrogação" />
                                                    </p>
                                                </a>
                                            </li>


                                            <li className="numDois">
                                                <img width="22" height="22" className="numDois-icon" src="/assets/numero_dois.svg" alt="Ícone número dois" />
                                                <a href="https://youtube.com/shorts/wjQzUadWqNQ" target="_blank" rel="noopener noreferrer"><p>Carta de Concessão - PDF migrado do Meu INSS.</p></a>
                                                <a
                                                    className=""
                                                    href="https://youtube.com/shorts/wjQzUadWqNQ"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <p className='no-bottom-margin dark-green-underline no-gap saiba-como'>
                                                        <img width="12" src="/assets/interrogacao_icon.svg" alt="Ícone de interrogação" />
                                                    </p>
                                                </a>
                                            </li>

                                        </ul>

                                        <div className='links-inss'>
                                            <span>Links de acesso:</span>
                                            <a href='https://meu.inss.gov.br/' target="_blank" rel="noopener noreferrer">https://meu.inss.gov.br/</a> {isMobile ? '' : '-'}
                                            <a href='https://www.gov.br/pt-br' target="_blank" rel="noopener noreferrer">https://www.gov.br/</a>
                                        </div>

                                    </div>
                                </div>


                                <div className='row' id="uploaders">

                                    <div className='gap'>

                                        <div className="file-uploader">
                                            <div className='file-title'>
                                                <p className='secText bold'>CNIS PDF</p>
                                            </div>
                                            <label htmlFor="cnis-upload">
                                                <img className="pdf-icon" src="/assets/SELECAO_DE_ARQUIVOS_PDF.svg" alt="Selecionar CNIS"></img>
                                                <div className='small-top-margin uploads-label'>
                                                    Clique aqui para buscar<br></br>o CNIS em seu {isMobile ? 'celular' : 'computador'}
                                                </div>
                                            </label>
                                            <input
                                                type="file"
                                                id="cnis-upload"
                                                accept="application/pdf"
                                                onChange={handleCnisUpload}
                                            />
                                            <div className='nomeArquivo-container'>
                                                {cnisFile && (
                                                    <div className='row'>
                                                        <p>{cnisFile.name}</p>
                                                        <p
                                                            onClick={() => handleRemoverArquivo('cnisFile')}
                                                            style={{
                                                                color: 'red',
                                                                cursor: 'pointer',
                                                                fontSize: '16px',
                                                                margin: 5,
                                                                userSelect: 'none',
                                                            }}
                                                            aria-label="Remover arquivo CNIS"
                                                            title="Remover arquivo"
                                                        >
                                                            X
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="error-message">
                                                {isSubmitted && errors.cnisFile && (
                                                    <span>*Obrigatório</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>



                                    <div className='gap'>

                                        <div className="file-uploader">
                                            <div className='file-title'>
                                                <p className='secText bold'>Carta de Concessão PDF</p>
                                            </div>
                                            <label htmlFor="concessao-upload">
                                                <img className="pdf-icon" src="/assets/SELECAO_DE_ARQUIVOS_PDF.svg" alt="Selecionar Carta de Concessão"></img>
                                                <div className='small-top-margin uploads-label'>
                                                    Clique aqui para buscar<br></br>a CARTA em seu {isMobile ? 'celular' : 'computador'}
                                                </div>
                                            </label>
                                            <input
                                                type="file"
                                                id="concessao-upload"
                                                accept="application/pdf"
                                                onChange={handleConcessaoUpload}
                                            />
                                            <div className='nomeArquivo-container'>
                                                {concessaoFile && (
                                                    <div className='row'>
                                                        <p>{concessaoFile.name}</p>
                                                        <p
                                                            onClick={() => handleRemoverArquivo('concessaoFile')}
                                                            style={{
                                                                color: 'red',
                                                                cursor: 'pointer',
                                                                fontSize: '16px',
                                                                margin: 5,
                                                                userSelect: 'none',
                                                            }}
                                                            aria-label="Remover arquivo CNIS"
                                                            title="Remover arquivo"
                                                        >
                                                            X
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="error-message">
                                                {isSubmitted && errors.concessaoFile && (
                                                    <span>*Obrigatório</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                {(() => {
                                    if (dibParaCalc) {


                                        const dipDate = new Date(
                                            String(dcbDate).split('/').reverse().join('-')
                                        );

                                        const tenYearsFromDip = new Date(dipDate);
                                        tenYearsFromDip.setFullYear(tenYearsFromDip.getFullYear() + 10);

                                        const now = new Date();

                                        // if (now > tenYearsFromDip) {
                                        //     showAlert('Oops! Sua carta tem mais de 10 anos.');
                                        //     setConcessaoFile(null);
                                        //     return;
                                        // }

                                        if (now < tenYearsFromDip) {
                                            const diffInMilliseconds = tenYearsFromDip - now;
                                            const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

                                            const months = Math.floor(diffInDays / 30);
                                            const days = diffInDays % 30;


                                            return (
                                                <div className="dates-display">

                                                    {dibParaCalc && (
                                                        <p><strong>DIB:</strong> {dibParaCalc}</p>
                                                    )}

                                                    {cartaData.dip && (
                                                        <p><strong>DIP:</strong> {cartaData.dip}</p>
                                                    )}

                                                    {cartaData.rmi && (
                                                        <p><strong>RMI: </strong> R$ {cartaData.rmi}</p>
                                                    )}



                                                    <p>
                                                        Faltam <strong>{months}</strong> {months === 1 ? 'mês' : 'meses'} e <strong>{days}</strong> {days === 1 ? 'dia' : 'dias'} para completar 10 anos.
                                                    </p>

                                                </div>
                                            );
                                        }
                                    }
                                    return null;
                                })()}


                                <div className="row top-margin">
                                    <button type="button" onClick={handleNavigate}>
                                        Voltar
                                    </button>
                                    <button type="submit" onClick={handleSubmitFreeTest}>
                                        Continuar com<br></br>teste grátis
                                    </button>
                                </div>
                            </div>


                        </div>
                    )}


                </div>


            )}


            {/* PAGAMENTO */}
            {currentStep === 1 && currentUser && emailVerified && (

                <>
                    <div className='pagamento'>


                        <h3>PAGAMENTO</h3>
                        <div className='gap'>
                            <div>
                                <div className="fichario">
                                    <div className='fichario-row' id="inputs">
                                        <div className="input-container">
                                            <label>NOME</label>
                                            <input
                                                id="nomeCompleto"
                                                type="text"
                                                name="nomeCompleto"
                                                placeholder="Nome completo"
                                                value={formData.nomeCompleto}
                                                onChange={handleInputChange}
                                                className={errors.nomeCompleto ? "error" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.nomeCompleto && (
                                                    <span>*Obrigatório</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>



                                    <div className='fichario-row' id="inputs">

                                        <div className="input-container">
                                            <label>CPF</label>
                                            <input
                                                type="text"
                                                name="cpf"
                                                id="cpf"
                                                placeholder="CPF"
                                                value={formData.cpf}
                                                onChange={handleInputChange}
                                                maxLength={14}
                                                className={errors.cpf ? "error" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.cpf && (
                                                    <span>{errors.cpf}</span>
                                                )}
                                            </div>
                                        </div>

                                    </div>


                                    <div className='fichario-row' id="inputs">

                                        <div className="input-container">
                                            <label>CELULAR COM DDD</label>
                                            <input
                                                type="text"
                                                name="celular"
                                                id="celular"
                                                placeholder="Celular com DDD"
                                                value={formData.celular}
                                                onChange={handleInputChange}
                                                maxLength={14}
                                                className={errors.celular ? "error" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.celular && (
                                                    <span>{errors.celular}</span>
                                                )}
                                            </div>
                                        </div>

                                    </div>


                                    <div className='fichario-row' id="inputs-cidade">

                                        <div className="input-container">
                                            <label>CEP</label>
                                            <input
                                                type="text"
                                                id="cep"
                                                name="cep"
                                                placeholder="CEP"
                                                value={formData.cep}
                                                onChange={handleInputChange}
                                                maxLength={9}
                                                className={errors.cep ? "error" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.cep && (
                                                    <span>{errors.cep}</span>
                                                )}
                                            </div>

                                        </div>


                                        <div className="input-container">
                                            <label>ESTADO</label>
                                            <input
                                                id="estado"
                                                type="text"
                                                name="estado"
                                                placeholder="Estado"
                                                disabled
                                                value={formData.estado}
                                                onChange={handleInputChange}
                                                maxLength={2}
                                                className={errors.estado ? "error" : ""}
                                            />
                                        </div>

                                    </div>





                                    <div className='fichario-row' id="inputs-cidade">

                                        <div className="input-container">
                                            <label>CIDADE</label>
                                            <input
                                                id="cidade"
                                                type="text"
                                                name="cidade"
                                                placeholder="Cidade"
                                                disabled
                                                value={formData.cidade}
                                                onChange={handleInputChange}
                                                maxLength={32}
                                                className={errors.cidade ? "error" : ""}
                                            />
                                        </div>


                                        <div className="input-container">
                                            <label>N°</label>
                                            <input
                                                id="numero"
                                                type="number"
                                                name="numero"
                                                placeholder="N°"
                                                value={formData.numero}
                                                onChange={handleInputChange}
                                                maxLength={7}
                                                min="0"
                                                step="1"
                                                className={errors.numero ? "error" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.numero && (
                                                    <span>*Obrigatório</span>
                                                )}
                                            </div>
                                        </div>

                                    </div>





                                    {cepSemBairro && (
                                        <div className="input-container">
                                            <label>Bairro</label>
                                            <input
                                                id="bairro"
                                                type="text"
                                                name="bairro"
                                                placeholder="bairro"
                                                value={formData.bairro}
                                                onChange={handleInputChange}
                                                className={errors.bairro ? "error" : ""}
                                            />
                                            <div className="error-message">
                                                {isSubmitted && errors.bairro && (
                                                    <span>*Obrigatório</span>
                                                )}
                                            </div>
                                        </div>
                                    )}


                                    <div className="input-container">
                                        <label>RUA</label>
                                        <input
                                            id="rua"
                                            type="text"
                                            name="rua"
                                            placeholder="Rua"
                                            value={formData.rua}
                                            onChange={handleInputChange}
                                            className={errors.rua ? "error" : ""}
                                        />
                                        <div className="error-message">
                                            {isSubmitted && errors.rua && (
                                                <span>*Obrigatório</span>
                                            )}
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>



                        <div className='checkout'>

                            <div className="metodo-pagamento">
                                <div className='metodo-container'>
                                    <img className="pg-icons" src="/assets/pixIcon.svg" alt="" aria-hidden="true"></img>
                                    <label>
                                        <input
                                            type="radio"
                                            value="pix"
                                            checked={metodoPagamento === "pix"}
                                            onChange={handleMetodoPagamentoChange}
                                        />
                                        Pix
                                    </label>
                                </div>

                                <div className='metodo-container'>
                                    <img className="pg-icons" src="/assets/twoCardsIcon.svg" alt="" aria-hidden="true"></img>
                                    <label>
                                        <input
                                            type="radio"
                                            value="cartao"
                                            checked={metodoPagamento === "cartao"}
                                            onChange={handleMetodoPagamentoChange}
                                        />
                                        Cartão de Crédito
                                    </label>
                                </div>

                            </div>


                            <div className='pagamentos-row'>

                                {metodoPagamento === "pix" && (
                                    <div className='Pix'>

                                        {qrCodeGerado && (
                                            <div>
                                                <h2 className='top-margin underline'>PIX</h2>
                                                <div ref={pixRef} style={{ textAlign: 'center', marginTop: 10 }}>
                                                    <Timer
                                                        qrCodeImage={qrCodeImage}
                                                        copiaColaPix={copiaColaPix}
                                                        tempoExpiracao={tempoExpiracao}
                                                        onExpire={resetPix}
                                                    />
                                                </div>

                                                <button className='top-margin' type="button" onClick={() => handleCheckPayment(paymentId)} disabled={!paymentId}>
                                                    Já fiz meu pagamento!
                                                </button>
                                            </div>
                                        )}


                                    </div>

                                )}


                                {metodoPagamento === "cartao" && (
                                    <div className='top-margin'>


                                        <h2 className='top-margin underline'>Cartão de Crédito</h2>

                                        <div className='ccOutro'>
                                            <p>Usar o cartão de outra pessoa:</p>
                                            <input checked={ccOutraPessoa} onClick={handleCcOutraPessoa} type='checkbox'></input>
                                        </div>


                                        <div className='gap'>
                                            {ccOutraPessoa && (
                                                <>
                                                    <div className='inputsPG'>
                                                        <div className="fichario">
                                                            <div className='fichario-row' id="inputs">
                                                                <div className="input-container">
                                                                    <label>NOME</label>
                                                                    <input
                                                                        id="nomeCompleto"
                                                                        type="text"
                                                                        name="nomeCompletoOutro"
                                                                        placeholder="Nome completo"
                                                                        value={formData.nomeCompletoOutro}
                                                                        onChange={handleInputChange}
                                                                        className={errors.nomeCompletoOutro ? "error" : ""}
                                                                    />
                                                                    <div className="error-message">
                                                                        {isSubmitted && errors.nomeCompletoOutro && (
                                                                            <span>*Obrigatório</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>



                                                            <div className='fichario-row' id="inputs">

                                                                <div className="input-container">
                                                                    <label>CPF</label>
                                                                    <input
                                                                        type="text"
                                                                        name="cpfOutro"
                                                                        id="cpf"
                                                                        placeholder="CPF"
                                                                        value={formData.cpfOutro}
                                                                        onChange={handleInputChange}
                                                                        maxLength={14}
                                                                        className={errors.cpfOutro ? "error" : ""}
                                                                    />
                                                                    <div className="error-message">
                                                                        {isSubmitted && errors.cpfOutro && (
                                                                            <span>{errors.cpfOutro}</span>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                            </div>


                                                            <div className='fichario-row' id="inputs-cidade">

                                                                <div className="input-container">
                                                                    <label>CEP</label>
                                                                    <input
                                                                        type="text"
                                                                        id="cep"
                                                                        name="cepOutro"
                                                                        placeholder="CEP"
                                                                        value={formData.cepOutro}
                                                                        onChange={handleInputChange}
                                                                        maxLength={9}
                                                                        className={errors.cepOutro ? "error" : ""}
                                                                    />
                                                                    <div className="error-message">
                                                                        {isSubmitted && errors.cepOutro && (
                                                                            <span>{errors.cepOutro}</span>
                                                                        )}
                                                                    </div>

                                                                </div>


                                                                <div className="input-container">
                                                                    <label>ESTADO</label>
                                                                    <input
                                                                        id="estado"
                                                                        type="text"
                                                                        name="estadoOutro"
                                                                        placeholder="Estado"
                                                                        disabled
                                                                        value={formData.estadoOutro}
                                                                        onChange={handleInputChange}
                                                                        maxLength={2}
                                                                        className={errors.estadoOutro ? "error" : ""}
                                                                    />
                                                                </div>

                                                            </div>





                                                            <div className='fichario-row' id="inputs-cidade">

                                                                <div className="input-container">
                                                                    <label>CIDADE</label>
                                                                    <input
                                                                        id="cidade"
                                                                        type="text"
                                                                        name="cidadeOutro"
                                                                        placeholder="Cidade"
                                                                        disabled
                                                                        value={formData.cidadeOutro}
                                                                        onChange={handleInputChange}
                                                                        maxLength={32}
                                                                        className={errors.cidadeOutro ? "error" : ""}
                                                                    />
                                                                </div>


                                                                <div className="input-container">
                                                                    <label>N°</label>
                                                                    <input
                                                                        id="numero"
                                                                        type="number"
                                                                        name="numeroOutro"
                                                                        placeholder="N°"
                                                                        value={formData.numeroOutro}
                                                                        onChange={handleInputChange}
                                                                        maxLength={7}
                                                                        min="0"
                                                                        step="1"
                                                                        className={errors.numeroOutro ? "error" : ""}
                                                                    />
                                                                    <div className="error-message">
                                                                        {isSubmitted && errors.numeroOutro && (
                                                                            <span>*Obrigatório</span>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                            </div>



                                                            {cepSemBairroOutro && (
                                                                <div className="input-container">
                                                                    <label>Bairro</label>
                                                                    <input
                                                                        id="bairro"
                                                                        type="text"
                                                                        name="bairroOutro"
                                                                        placeholder="bairro"
                                                                        value={formData.bairroOutro}
                                                                        onChange={handleInputChange}
                                                                        className={errors.bairroOutro ? "error" : ""}
                                                                    />
                                                                    <div className="error-message">
                                                                        {isSubmitted && errors.bairroOutro && (
                                                                            <span>*Obrigatório</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}



                                                            <div className="input-container">
                                                                <label>RUA</label>
                                                                <input
                                                                    id="rua"
                                                                    type="text"
                                                                    name="ruaOutro"
                                                                    placeholder="Rua"
                                                                    value={formData.ruaOutro}
                                                                    onChange={handleInputChange}
                                                                    className={errors.ruaOutro ? "error" : ""}
                                                                />
                                                                <div className="error-message">
                                                                    {isSubmitted && errors.ruaOutro && (
                                                                        <span>*Obrigatório</span>
                                                                    )}
                                                                </div>
                                                            </div>



                                                        </div>
                                                    </div>
                                                    <h4 className=''>Dados do Cartão</h4>
                                                </>
                                            )}
                                        </div>



                                        <form id="form3ds">

                                            <div className='inputsPG'>

                                                {/* Nome */}
                                                <div className='row'>
                                                    <div className="input-container">
                                                        <label><span className='alert'>*</span>NOME DO TITULAR</label>
                                                        <input
                                                            id="nomeCartao"
                                                            ref={nomeCartaoRef}
                                                            type="text"
                                                            name="nomeCartao"
                                                            value={formData.nomeCartao.replace(/\d/g, "").toUpperCase()}
                                                            onChange={handleInputChange}
                                                            placeholder="Digite o nome impresso no cartão"
                                                            className={`bp_sop_cardholdername bpmpi_cardholdername ${errors.nomeCartao ? "error" : ""}`}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Número do cartão */}
                                                <div className='row'>
                                                    <div className="input-container">
                                                        <label><span className='alert'>*</span>NÚMERO DO CARTÃO</label>
                                                        <input
                                                            id="numeroCartao"
                                                            type="text"
                                                            name="numeroCartao"
                                                            value={formData.numeroCartao}
                                                            maxLength={19}
                                                            onChange={handleInputChange}
                                                            placeholder="Digite somente os número do cartão"
                                                            className={`${errors.numeroCartao ? "error" : ""}`}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='row' id="vencimentoCVC">

                                                    {/* Vencimento */}
                                                    <div className='row'>
                                                        <div className="input-container">
                                                            <label><span className='alert'>*</span>VENCIMENTO</label>
                                                            <input
                                                                id="vencimento"
                                                                type="text"
                                                                name="vencimento"
                                                                value={formData.vencimento}
                                                                onChange={(e) => {
                                                                    const formattedValue = formatVencimento(e.target.value);
                                                                    handleInputChange({ target: { name: "vencimento", value: formattedValue } });
                                                                }}
                                                                placeholder="MM/AA"
                                                                className={`${errors.vencimento ? "error" : ""}`}
                                                            />

                                                        </div>
                                                    </div>

                                                    {/* CVC */}
                                                    <div className='row'>
                                                        <div className="input-container">
                                                            <label><span className='alert'>*</span>CVC</label>
                                                            <input
                                                                id="cvc"
                                                                type="text"
                                                                name="cvc"
                                                                value={formData.cvc}
                                                                onChange={(e) => {
                                                                    const formattedValue = e.target.value.replace(/\D/g, "").slice(0, 4);
                                                                    handleInputChange({ target: { name: "cvc", value: formattedValue } });
                                                                }}
                                                                placeholder="XXX"
                                                                className={`bp-sop-cardcvv bpmpi_cardcvv ${errors.cvc ? "error" : ""}`}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>

                                                {/* Parcelas */}
                                                <div className='row top'>
                                                    <div className="input-container inputs-cc">
                                                        <label><span className='alert'></span>PARCELAS</label>
                                                        <select
                                                            id="parcelas"
                                                            name="parcelas"
                                                            value={formData.parcelas || "1"}
                                                            onChange={handleInputChange}
                                                            className={`bpmpi_installments ${errors.parcelas ? "error" : ""}`}
                                                        >
                                                            <option value="1">À vista - R$312,00</option>
                                                            <option value="2">2x de R$156,00</option>
                                                            <option value="3">3x de R$104,00</option>
                                                            <option value="4">4x de R$78,00</option>
                                                            <option value="5">5x de R$62,40</option>
                                                            <option value="6">6x de R$52,00</option>
                                                        </select>
                                                    </div>
                                                </div>


                                                <input type="hidden" className="bpmpi_accesstoken" value="" />
                                                <input type="hidden" className="bpmpi_auth" value="true" />
                                                <input type="hidden" className="bpmpi_auth_notifyonly" value="true" />


                                                <input type="hidden" className="bp-sop-cardnumber bpmpi_cardnumber" value={formData.numeroCartao ? formData.numeroCartao.replace(/\D/g, '') : ''} />
                                                <input type="hidden" className="bp-sop-cardexpirationdate bpmpi_cardexpirationdate" value={formData.vencimento ? formData.vencimento.replace(/(\d{2})\/(\d{2})/, (m, mm, yy) => `${mm}/20${yy}`) : ''} />
                                                <input type="hidden" className="bpmpi_cardexpirationmonth" value={formData.vencimento.split('/')[0] || ''} />
                                                <input type="hidden" className="bpmpi_cardexpirationyear" value={formData.vencimento.split('/')[1] || ''} />


                                                <input type="hidden" className="bpmpi_billto_email" value={currentUser.email} />
                                                <input type="hidden" className="bpmpi_billto_name" value={ccOutraPessoa ? (formData.nomeCompletoOutro || '') : (formData.nomeCompleto || '')} />
                                                <input type="hidden" className="bpmpi_billto_street1" value={ccOutraPessoa ? (formData.rua || '') : (formData.rua || '')} />
                                                <input type="hidden" className="bpmpi_billto_city" value={ccOutraPessoa ? (formData.cidade || '') : (formData.cidade || '')} />
                                                <input type="hidden" className="bpmpi_billto_state" value={ccOutraPessoa ? (formData.estado || '') : (formData.estado || '')} />
                                                <input type="hidden" className="bpmpi_billto_zipcode" value={ccOutraPessoa ? (formData.cep || '') : (formData.cep || '')} />
                                                <input type="hidden" className="bpmpi_billto_country" value="BR" />
                                                <input type="hidden" className="bpmpi_billto_phonenumber" value={formData.celular ? formData.celular.replace(/\D/g, '') : ''} />

                                                <input type="hidden" className="bpmpi_ordernumber" value="PEDIDO-TESTE-123456" />
                                                <input type="hidden" className="bpmpi_totalamount" value="11800" />
                                                <input type="hidden" className="bpmpi_currency" value="986" />
                                                {/* <input type="hidden" className="bpmpi_installments" value={formData.parcelas}/> */}
                                                <input type="hidden" className="bpmpi_paymentmethod" value="credit" />

                                                <input type="hidden" className="bpmpi_transaction_mode" value="R" />
                                                <input type="hidden" className="bpmpi_merchant_name" value="Loja Exemplo Ltda" />
                                                <input type="hidden" className="bpmpi_merchant_url" value="https://minhaloja.com.br" />
                                                <input type="hidden" className="bpmpi_order_productcode" value="PHY" />



                                            </div>




                                            <div>
                                                <button type="button" onClick={handlePagamento}>
                                                    Finalizar
                                                </button>
                                            </div>


                                        </form>


                                    </div>

                                )}

                            </div>


                        </div>

                    </div>

                    <button className="medium-top-margin" type="button" onClick={handlePrevious}>
                        Voltar
                    </button>


                </>

            )}



        </div>
    );
};



export default Steps;